import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `Upload` special type represents a file to be uploaded in the same HTTP request as specified by
   *  [graphql-multipart-request-spec](https://github.com/jaydenseric/graphql-multipart-request-spec).
   */
  Upload: { input: any; output: any; }
};

/** Валюта */
export type AucDeposit = {
  __typename?: 'AucDeposit';
  /** Сумма */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Вывод даты разными способами */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Валюта */
  currency?: Maybe<Currency>;
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};


/** Валюта */
export type AucDepositCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Валюта */
export type AucDepositDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Аукцион */
export type Auction = {
  __typename?: 'Auction';
  /** POS номер */
  POS: Scalars['String']['output'];
  /** Список связок ползователь - аукцион */
  UserToAuctions?: Maybe<Array<Maybe<UserToAuction>>>;
  /** Адрес */
  address?: Maybe<Scalars['String']['output']>;
  /** Середнее время доставки авто на ярд в днях */
  carDeliveryDays?: Maybe<Scalars['Int']['output']>;
  /** Город базовый */
  city?: Maybe<City>;
  /** Контрагент */
  counterparty?: Maybe<Counterparty>;
  /** Среднее время доставки документов в днях */
  docsDeliveryDays?: Maybe<Scalars['Int']['output']>;
  /** Время нахождения сотрудника на аукционе */
  employeeTimeTo?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  /** Дней на вывоз после покупки */
  exportDeadlineDays?: Maybe<Scalars['Int']['output']>;
  /** Остаток лимита неоплаченных покупок */
  exportPurchaseLeft?: Maybe<Scalars['Float']['output']>;
  /** Лимит неоплаченных покупок которые можно забрать */
  exportPurchaseLimit?: Maybe<Scalars['Float']['output']>;
  /** Правила вывоза */
  exportRules?: Maybe<Scalars['String']['output']>;
  /** Факс */
  fax?: Maybe<Scalars['String']['output']>;
  /** Правила форклифта */
  forkliftRules?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Признак заказа осмотра сотрудником ААН */
  isAANReviewAvaiable?: Maybe<Scalars['Boolean']['output']>;
  /** Возможность заказать осмотр непосредственно у аукциона */
  isAuctionReviewAvaiable: Scalars['Boolean']['output'];
  /** Признак аукцион автоставок */
  isAutoTrade?: Maybe<Scalars['Boolean']['output']>;
  /** Признак удаления */
  isDeleted: Scalars['Boolean']['output'];
  /** Признак аукциона без своего ярда */
  isNoYard?: Maybe<Scalars['Boolean']['output']>;
  /** Признак тендерного аукциона */
  isTender?: Maybe<Scalars['Boolean']['output']>;
  /** Неограниченный вывоз авто */
  isUnlimitedExport: Scalars['Boolean']['output'];
  /** Привязанные аукционы лота */
  lotAuctions?: Maybe<Array<LotAuction>>;
  /** Разделы аукциона */
  lotRanges?: Maybe<Array<Maybe<LotRange>>>;
  /** Название английское */
  nameEn: Scalars['String']['output'];
  /** Название японское */
  nameJp: Scalars['String']['output'];
  /** Телефон */
  phone?: Maybe<Scalars['String']['output']>;
  /** Комиссия за покупку */
  purchaseCommission: Scalars['Float']['output'];
  /** Синонимы */
  synonyms: Array<Synonym>;
  /** Коэффициент снижения ставки тендерного аукциона */
  tenderBidRate?: Maybe<Scalars['Int']['output']>;
  /** Время ставки на тендер */
  tenderTimeTo?: Maybe<Scalars['String']['output']>;
  /** День торгов */
  tradeDay: Scalars['Int']['output'];
};

/** Баланс контрагента по валюте */
export type Balance = {
  __typename?: 'Balance';
  /** Валюта */
  currency?: Maybe<Currency>;
  /** Текущий баланс */
  currentBalance?: Maybe<Scalars['Float']['output']>;
  /** Лимит задолженности */
  debtLimitAmount?: Maybe<Scalars['Float']['output']>;
  /** Отсрочка в днях */
  deferDaysLimit?: Maybe<Scalars['Int']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Форма денег */
  moneyType?: Maybe<TypeOfMoney>;
  /** Остаток лимита задолженности */
  remainingDebtLimitAmount?: Maybe<Scalars['Float']['output']>;
};

/** Транзакция по балансу */
export type BalanceTransaction = {
  __typename?: 'BalanceTransaction';
  /** Баланс после */
  amountAfter?: Maybe<Scalars['Float']['output']>;
  /** Баланс до */
  amountBefore?: Maybe<Scalars['Float']['output']>;
  /** СУмма в валюте баланса */
  amountClear?: Maybe<Scalars['Float']['output']>;
  /** Сумма в валюте транзакции */
  amountDirty?: Maybe<Scalars['Float']['output']>;
  /** Баланс */
  balance?: Maybe<Balance>;
  /** Вывод даты разными способами */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Валюта */
  currency?: Maybe<Currency>;
  /** Курс */
  currencyRate?: Maybe<Scalars['Float']['output']>;
  /** Начисление долга */
  debtAccrual?: Maybe<DebtAccrual>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Форма денег */
  moneyType?: Maybe<TypeOfMoney>;
  /** Тип транзакции */
  type?: Maybe<TypeOfBalanceTransaction>;
  /** Вывод даты разными способами */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Кто провел */
  user?: Maybe<User>;
};


/** Транзакция по балансу */
export type BalanceTransactionCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Транзакция по балансу */
export type BalanceTransactionUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Группа ставок */
export type BidGroup = {
  __typename?: 'BidGroup';
  /** Название группы */
  bidGroupName?: Maybe<BidGroupName>;
  /** Список ставок */
  bids?: Maybe<Array<Maybe<LotBid>>>;
  /** Комментарий */
  comment?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Закрыта или нет */
  isClosed: Scalars['Boolean']['output'];
  /** Купить лотов */
  lotsToBuy: Scalars['Int']['output'];
  /** Автор ставки */
  user?: Maybe<User>;
};

/** Статус ставки */
export type BidGroupName = {
  __typename?: 'BidGroupName';
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Коэффициент ставки от наличия и потребности ДВС */
export type BidRateEngine = {
  __typename?: 'BidRateEngine';
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Признак увеличения ставки при уменьшении диапазона */
  isStepDownIncrease: Scalars['Boolean']['output'];
  /** Признак увеличения ставки при увеличении диапазона */
  isStepUpIncrease: Scalars['Boolean']['output'];
  /** Начало диапазона соотношения */
  rangeFrom: Scalars['Int']['output'];
  /** Конец диапазона соотношения */
  rangeTo: Scalars['Int']['output'];
  /** Модификатор уменьшения диапазона */
  stepDownModifier: Scalars['Float']['output'];
  /** Модификатор увеличения диапазона */
  stepUpModifier: Scalars['Float']['output'];
};


/** Коэффициент ставки от наличия и потребности ДВС */
export type BidRateEngineDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Коэффициент ставки от лотов и торгов */
export type BidRateLot = {
  __typename?: 'BidRateLot';
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Признак увеличения ставки при уменьшении диапазона */
  isStepDownIncrease: Scalars['Boolean']['output'];
  /** Признак увеличения ставки при увеличении диапазона */
  isStepUpIncrease: Scalars['Boolean']['output'];
  /** Начало диапазона соотношения */
  rangeFrom: Scalars['Int']['output'];
  /** Конец диапазона соотношения */
  rangeTo: Scalars['Int']['output'];
  /** Модификатор уменьшения диапазона */
  stepDownModifier: Scalars['Float']['output'];
  /** Модификатор увеличения диапазона */
  stepUpModifier: Scalars['Float']['output'];
};


/** Коэффициент ставки от лотов и торгов */
export type BidRateLotDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Тип навального продукта для типа ставки */
export type BidTypeBulk = {
  __typename?: 'BidTypeBulk';
  /** Тип ставки */
  bidType?: Maybe<TypeOfBid>;
  /** Тип навального продукта */
  bulkProduct?: Maybe<BulkProduct>;
  id: Scalars['ID']['output'];
};

/** Тип запчасти для типа ставки */
export type BidTypeGenerationPart = {
  __typename?: 'BidTypeGenerationPart';
  /** Тип ставки */
  bidType?: Maybe<TypeOfBid>;
  /** Тип запчасти */
  generationPartType?: Maybe<TypeOfGenerationPart>;
  id: Scalars['ID']['output'];
};

/** Марка */
export type Brand = {
  __typename?: 'Brand';
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Популярная */
  isPopular: Scalars['Boolean']['output'];
  /** Список марок лота */
  lotBrands?: Maybe<Array<Maybe<LotBrand>>>;
  /** Производитель */
  manufacturer?: Maybe<Manufacturer>;
  /** Название международное */
  nameEn: Scalars['String']['output'];
  /** Название для фронта полное */
  nameFront: Scalars['String']['output'];
  /** Название японское */
  nameJp: Scalars['String']['output'];
};


/** Марка */
export type BrandDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Тип навального продукта */
export type BulkProduct = {
  __typename?: 'BulkProduct';
  /** Цена покупки */
  buyAmount: Scalars['Float']['output'];
  /** Скидка от цены при покупке */
  buyDiscount: Scalars['Float']['output'];
  /** Дефолтное количество */
  defaultQuantity?: Maybe<Scalars['Float']['output']>;
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Признак дефолтного продукта */
  isDefaultProduct: Scalars['Boolean']['output'];
  /** Можно продавать в офисе */
  isSaleOffice: Scalars['Boolean']['output'];
  /** Можно продавать на ярде */
  isSaleYard: Scalars['Boolean']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Цена продажи */
  saleAmount: Scalars['Float']['output'];
  /** Скидка от цены при продаже */
  saleDiscount: Scalars['Float']['output'];
  /** единица измерения */
  unitOfMeasure?: Maybe<UnitOfMeasure>;
};


/** Тип навального продукта */
export type BulkProductDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Доставщик */
export type Carrier = {
  __typename?: 'Carrier';
  /** Комментарий */
  comment?: Maybe<Scalars['String']['output']>;
  /** Контрагент */
  counterparty?: Maybe<Counterparty>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Подотчетная операция с наличными */
export type CashAccountableOperation = {
  __typename?: 'CashAccountableOperation';
  /** Количество после */
  countAfter?: Maybe<Scalars['Float']['output']>;
  /** Количество до */
  countBefore?: Maybe<Scalars['Float']['output']>;
  /** Количество */
  countChange?: Maybe<Scalars['Float']['output']>;
  /** Вывод даты разными способами */
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Тип операции */
  operationType?: Maybe<TypeOfAccountableOperation>;
  /** Вывод даты разными способами */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Кто провел операцию */
  user?: Maybe<User>;
  /** Баланс */
  userBalance?: Maybe<CashBalance>;
};


/** Подотчетная операция с наличными */
export type CashAccountableOperationCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Подотчетная операция с наличными */
export type CashAccountableOperationUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CashAccountableOperationPagination = {
  __typename?: 'CashAccountableOperationPagination';
  /** Current page of the cursor */
  current_page: Scalars['Int']['output'];
  /** List of items on the current page */
  data: Array<CashAccountableOperation>;
  /** Number of the first item returned */
  from?: Maybe<Scalars['Int']['output']>;
  /** Determines if cursor has more pages after the current page */
  has_more_pages: Scalars['Boolean']['output'];
  /** The last page (number of pages) */
  last_page: Scalars['Int']['output'];
  /** Number of items returned per page */
  per_page: Scalars['Int']['output'];
  /** Number of the last item returned */
  to?: Maybe<Scalars['Int']['output']>;
  /** Number of total items selected by the query */
  total: Scalars['Int']['output'];
};

/** Баланс наличных у сотрудника */
export type CashBalance = {
  __typename?: 'CashBalance';
  /** Валюта */
  currency?: Maybe<Currency>;
  /** Текущий баланс */
  currentBalance?: Maybe<Scalars['Float']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Форма денег */
  moneyType?: Maybe<TypeOfMoney>;
  /** Сотрудник */
  user?: Maybe<User>;
};

export type CashHistoryFilterInput = {
  /** ID баланса наличных сотрудника */
  userBalance?: InputMaybe<Scalars['ID']['input']>;
};

/** Строковые поля каталога для справочника distinct */
export enum CatalogDistinctField {
  CarnameEn = 'carnameEn',
  Color = 'color',
  Grade = 'grade',
  MakerEn = 'makerEn'
}

/** AUCNET shared inventory vehicle */
export type CatalogVehicle = {
  __typename?: 'CatalogVehicle';
  abs?: Maybe<Scalars['Int']['output']>;
  accidentFlag?: Maybe<Scalars['String']['output']>;
  airCondition?: Maybe<Scalars['Int']['output']>;
  airbag?: Maybe<Scalars['Int']['output']>;
  aisComment01?: Maybe<Scalars['String']['output']>;
  aisComment02?: Maybe<Scalars['String']['output']>;
  aisComment03?: Maybe<Scalars['String']['output']>;
  aisComment04?: Maybe<Scalars['String']['output']>;
  aisComment05?: Maybe<Scalars['String']['output']>;
  aisComment06?: Maybe<Scalars['String']['output']>;
  aisComment07?: Maybe<Scalars['String']['output']>;
  aisComment08?: Maybe<Scalars['String']['output']>;
  aisComment09?: Maybe<Scalars['String']['output']>;
  aisComment10?: Maybe<Scalars['String']['output']>;
  aisComment11?: Maybe<Scalars['String']['output']>;
  aisComment12?: Maybe<Scalars['String']['output']>;
  aisComment13?: Maybe<Scalars['String']['output']>;
  aisComment14?: Maybe<Scalars['String']['output']>;
  aisComment15?: Maybe<Scalars['String']['output']>;
  aisComment16?: Maybe<Scalars['String']['output']>;
  aisComment17?: Maybe<Scalars['String']['output']>;
  aisComment18?: Maybe<Scalars['String']['output']>;
  aisComment19?: Maybe<Scalars['String']['output']>;
  aisComment20?: Maybe<Scalars['String']['output']>;
  aisCommentEn?: Maybe<Scalars['String']['output']>;
  aisScoreExt?: Maybe<Scalars['String']['output']>;
  aisScoreInt?: Maybe<Scalars['String']['output']>;
  aisScoreTotal?: Maybe<Scalars['String']['output']>;
  aucAnnouncement?: Maybe<Scalars['String']['output']>;
  aucNoticeInfo?: Maybe<Scalars['String']['output']>;
  aw?: Maybe<Scalars['Int']['output']>;
  backcamera?: Maybe<Scalars['Int']['output']>;
  bodytypeCd?: Maybe<Scalars['Int']['output']>;
  capacityCd?: Maybe<Scalars['Int']['output']>;
  carbodyHeight?: Maybe<Scalars['Int']['output']>;
  carbodyHeightRef?: Maybe<Scalars['Int']['output']>;
  carbodyLength?: Maybe<Scalars['Int']['output']>;
  carbodyLengthRef?: Maybe<Scalars['Int']['output']>;
  carbodyNo?: Maybe<Scalars['String']['output']>;
  carbodyWidth?: Maybe<Scalars['Int']['output']>;
  carbodyWidthRef?: Maybe<Scalars['Int']['output']>;
  carcategoryCd?: Maybe<Scalars['Int']['output']>;
  carname?: Maybe<Scalars['String']['output']>;
  carnameCd?: Maybe<Scalars['Int']['output']>;
  carnameEn?: Maybe<Scalars['String']['output']>;
  carnameWrap?: Maybe<Scalars['String']['output']>;
  cartypeCd?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  colorCd1?: Maybe<Scalars['Int']['output']>;
  colorCd2?: Maybe<Scalars['Int']['output']>;
  colorNo?: Maybe<Scalars['Int']['output']>;
  correction?: Maybe<Scalars['String']['output']>;
  doorCd?: Maybe<Scalars['String']['output']>;
  driveCd?: Maybe<Scalars['String']['output']>;
  estimationDate?: Maybe<Scalars['String']['output']>;
  estimationExpireDate?: Maybe<Scalars['String']['output']>;
  etc?: Maybe<Scalars['Int']['output']>;
  exhaust?: Maybe<Scalars['Float']['output']>;
  exhaustCd?: Maybe<Scalars['String']['output']>;
  floormat?: Maybe<Scalars['Int']['output']>;
  fuelCd?: Maybe<Scalars['String']['output']>;
  gearCd?: Maybe<Scalars['Int']['output']>;
  goodValueFlag?: Maybe<Scalars['Int']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  gradeSub?: Maybe<Scalars['String']['output']>;
  gradeSubEn?: Maybe<Scalars['String']['output']>;
  gradeTypeCd?: Maybe<Scalars['Int']['output']>;
  guaranteeFlag?: Maybe<Scalars['Int']['output']>;
  handleCd?: Maybe<Scalars['Int']['output']>;
  historyCd?: Maybe<Scalars['String']['output']>;
  iaucLotNo?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image1Uri?: Maybe<Scalars['String']['output']>;
  image2Uri?: Maybe<Scalars['String']['output']>;
  image3Uri?: Maybe<Scalars['String']['output']>;
  image4Uri?: Maybe<Scalars['String']['output']>;
  image5Uri?: Maybe<Scalars['String']['output']>;
  image6Uri?: Maybe<Scalars['String']['output']>;
  image7Uri?: Maybe<Scalars['String']['output']>;
  image8Uri?: Maybe<Scalars['String']['output']>;
  image9Uri?: Maybe<Scalars['String']['output']>;
  image10Uri?: Maybe<Scalars['String']['output']>;
  image11Uri?: Maybe<Scalars['String']['output']>;
  image12Uri?: Maybe<Scalars['String']['output']>;
  image13Uri?: Maybe<Scalars['String']['output']>;
  image14Uri?: Maybe<Scalars['String']['output']>;
  image15Uri?: Maybe<Scalars['String']['output']>;
  image16Uri?: Maybe<Scalars['String']['output']>;
  image17Uri?: Maybe<Scalars['String']['output']>;
  image18Uri?: Maybe<Scalars['String']['output']>;
  image19Uri?: Maybe<Scalars['String']['output']>;
  image20Uri?: Maybe<Scalars['String']['output']>;
  image21Uri?: Maybe<Scalars['String']['output']>;
  image22Uri?: Maybe<Scalars['String']['output']>;
  image23Uri?: Maybe<Scalars['String']['output']>;
  image24Uri?: Maybe<Scalars['String']['output']>;
  image25Uri?: Maybe<Scalars['String']['output']>;
  image26Uri?: Maybe<Scalars['String']['output']>;
  image27Uri?: Maybe<Scalars['String']['output']>;
  image28Uri?: Maybe<Scalars['String']['output']>;
  image29Uri?: Maybe<Scalars['String']['output']>;
  image30Uri?: Maybe<Scalars['String']['output']>;
  imageDate1?: Maybe<Scalars['String']['output']>;
  imageDate2?: Maybe<Scalars['String']['output']>;
  imageDate3?: Maybe<Scalars['String']['output']>;
  imageDate4?: Maybe<Scalars['String']['output']>;
  imageDate5?: Maybe<Scalars['String']['output']>;
  imageDate6?: Maybe<Scalars['String']['output']>;
  imageDate7?: Maybe<Scalars['String']['output']>;
  imageDate8?: Maybe<Scalars['String']['output']>;
  imageDate9?: Maybe<Scalars['String']['output']>;
  imageDate10?: Maybe<Scalars['String']['output']>;
  imageDate11?: Maybe<Scalars['String']['output']>;
  imageDate12?: Maybe<Scalars['String']['output']>;
  imageDate13?: Maybe<Scalars['String']['output']>;
  imageDate14?: Maybe<Scalars['String']['output']>;
  imageDate15?: Maybe<Scalars['String']['output']>;
  imageDate16?: Maybe<Scalars['String']['output']>;
  imageDate17?: Maybe<Scalars['String']['output']>;
  imageDate18?: Maybe<Scalars['String']['output']>;
  imageDate19?: Maybe<Scalars['String']['output']>;
  imageDate20?: Maybe<Scalars['String']['output']>;
  imageDate21?: Maybe<Scalars['String']['output']>;
  imageDate22?: Maybe<Scalars['String']['output']>;
  imageDate23?: Maybe<Scalars['String']['output']>;
  imageDate24?: Maybe<Scalars['String']['output']>;
  imageDate25?: Maybe<Scalars['String']['output']>;
  imageDate26?: Maybe<Scalars['String']['output']>;
  imageDate27?: Maybe<Scalars['String']['output']>;
  imageDate28?: Maybe<Scalars['String']['output']>;
  imageDate29?: Maybe<Scalars['String']['output']>;
  imageDate30?: Maybe<Scalars['String']['output']>;
  imageDateCaution?: Maybe<Scalars['String']['output']>;
  imageDateExhibit?: Maybe<Scalars['String']['output']>;
  imageDateSelfInspect?: Maybe<Scalars['String']['output']>;
  imageExistFlag1?: Maybe<Scalars['Int']['output']>;
  imageExistFlag2?: Maybe<Scalars['Int']['output']>;
  imageExistFlag3?: Maybe<Scalars['Int']['output']>;
  imageExistFlag4?: Maybe<Scalars['Int']['output']>;
  imageExistFlag5?: Maybe<Scalars['Int']['output']>;
  imageExistFlag6?: Maybe<Scalars['Int']['output']>;
  imageExistFlag7?: Maybe<Scalars['Int']['output']>;
  imageExistFlag8?: Maybe<Scalars['Int']['output']>;
  imageExistFlag9?: Maybe<Scalars['Int']['output']>;
  imageExistFlag10?: Maybe<Scalars['Int']['output']>;
  imageExistFlag11?: Maybe<Scalars['Int']['output']>;
  imageExistFlag12?: Maybe<Scalars['Int']['output']>;
  imageExistFlag13?: Maybe<Scalars['Int']['output']>;
  imageExistFlag14?: Maybe<Scalars['Int']['output']>;
  imageExistFlag15?: Maybe<Scalars['Int']['output']>;
  imageExistFlag16?: Maybe<Scalars['Int']['output']>;
  imageExistFlag17?: Maybe<Scalars['Int']['output']>;
  imageExistFlag18?: Maybe<Scalars['Int']['output']>;
  imageExistFlag19?: Maybe<Scalars['Int']['output']>;
  imageExistFlag20?: Maybe<Scalars['Int']['output']>;
  imageExistFlag21?: Maybe<Scalars['Int']['output']>;
  imageExistFlag22?: Maybe<Scalars['Int']['output']>;
  imageExistFlag23?: Maybe<Scalars['Int']['output']>;
  imageExistFlag24?: Maybe<Scalars['Int']['output']>;
  imageExistFlag25?: Maybe<Scalars['Int']['output']>;
  imageExistFlag26?: Maybe<Scalars['Int']['output']>;
  imageExistFlag27?: Maybe<Scalars['Int']['output']>;
  imageExistFlag28?: Maybe<Scalars['Int']['output']>;
  imageExistFlag29?: Maybe<Scalars['Int']['output']>;
  imageExistFlag30?: Maybe<Scalars['Int']['output']>;
  imageExistFlagCauction?: Maybe<Scalars['Int']['output']>;
  imageExistFlagSelfInspect?: Maybe<Scalars['Int']['output']>;
  /** Прокси-URL изображений */
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  importModelYear?: Maybe<Scalars['String']['output']>;
  importSerialNo?: Maybe<Scalars['String']['output']>;
  importTypeCd?: Maybe<Scalars['Int']['output']>;
  importYearUnknownFlag?: Maybe<Scalars['Int']['output']>;
  inStockRate?: Maybe<Scalars['Int']['output']>;
  infoPdfDate?: Maybe<Scalars['String']['output']>;
  infoPdfUri?: Maybe<Scalars['String']['output']>;
  inspectExpireDate?: Maybe<Scalars['Int']['output']>;
  inspectionPdfDate?: Maybe<Scalars['String']['output']>;
  inspectionPdfUri?: Maybe<Scalars['String']['output']>;
  inventoryNo?: Maybe<Scalars['String']['output']>;
  inventoryYear?: Maybe<Scalars['String']['output']>;
  keyless?: Maybe<Scalars['Int']['output']>;
  leatherSeat?: Maybe<Scalars['Int']['output']>;
  licenseNo1?: Maybe<Scalars['String']['output']>;
  licenseNo2?: Maybe<Scalars['String']['output']>;
  licenseNo3?: Maybe<Scalars['String']['output']>;
  licenseOffice?: Maybe<Scalars['String']['output']>;
  maker?: Maybe<Scalars['String']['output']>;
  makerCd?: Maybe<Scalars['String']['output']>;
  makerEn?: Maybe<Scalars['String']['output']>;
  manualFlag?: Maybe<Scalars['Int']['output']>;
  maxLoading?: Maybe<Scalars['Int']['output']>;
  mileage?: Maybe<Scalars['Float']['output']>;
  mileageFlag?: Maybe<Scalars['String']['output']>;
  mileageSymbol?: Maybe<Scalars['String']['output']>;
  missionCd?: Maybe<Scalars['Int']['output']>;
  modelCd?: Maybe<Scalars['String']['output']>;
  navi?: Maybe<Scalars['Int']['output']>;
  naviType?: Maybe<Scalars['Int']['output']>;
  negotiableFlag?: Maybe<Scalars['Int']['output']>;
  no8Cd?: Maybe<Scalars['String']['output']>;
  noDependsFlag?: Maybe<Scalars['String']['output']>;
  noteFlag?: Maybe<Scalars['Int']['output']>;
  noticeInfo?: Maybe<Scalars['String']['output']>;
  noticeInfoEn?: Maybe<Scalars['String']['output']>;
  noxpmCd?: Maybe<Scalars['String']['output']>;
  noxpmDate?: Maybe<Scalars['Int']['output']>;
  onRegistrationFlag?: Maybe<Scalars['String']['output']>;
  originTypeCd?: Maybe<Scalars['String']['output']>;
  prefName?: Maybe<Scalars['String']['output']>;
  /** Превью из Yandex S3 или первый прокси-URL */
  preview?: Maybe<Scalars['String']['output']>;
  recordFlag?: Maybe<Scalars['Int']['output']>;
  recycleFlag?: Maybe<Scalars['String']['output']>;
  recyleDeposit?: Maybe<Scalars['Int']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['Int']['output']>;
  repaintFlag?: Maybe<Scalars['String']['output']>;
  selfScoreInt?: Maybe<Scalars['Int']['output']>;
  selfScoreTotal?: Maybe<Scalars['Int']['output']>;
  sellerHashId?: Maybe<Scalars['String']['output']>;
  sellingPoint?: Maybe<Scalars['String']['output']>;
  sellingPointEn?: Maybe<Scalars['String']['output']>;
  shiftCd?: Maybe<Scalars['String']['output']>;
  smartKey?: Maybe<Scalars['Int']['output']>;
  strikeEndDate?: Maybe<Scalars['String']['output']>;
  strikeFlag?: Maybe<Scalars['Int']['output']>;
  strikeNightFlag?: Maybe<Scalars['Int']['output']>;
  strikePointFlag?: Maybe<Scalars['Int']['output']>;
  strikePrice?: Maybe<Scalars['Int']['output']>;
  strikeStartDate?: Maybe<Scalars['String']['output']>;
  styleSpecifyCd?: Maybe<Scalars['Int']['output']>;
  sunroof?: Maybe<Scalars['Int']['output']>;
  tv?: Maybe<Scalars['Int']['output']>;
  tvType?: Maybe<Scalars['Int']['output']>;
  updatedDate?: Maybe<Scalars['String']['output']>;
  vehicleType: Scalars['String']['output'];
  welfareCd?: Maybe<Scalars['String']['output']>;
  wholesalePrice?: Maybe<Scalars['Int']['output']>;
};

/** Модель катализатора */
export type Catalyst = {
  __typename?: 'Catalyst';
  entityType: Scalars['String']['output'];
  /** Список комплектаций с катализатором */
  equipments?: Maybe<Array<Maybe<ModelEquipment>>>;
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Цена продажи */
  salePrice: Scalars['Float']['output'];
};

/** Чат */
export type Chat = {
  __typename?: 'Chat';
  /** Участники */
  chatParticipants?: Maybe<Array<Maybe<ChatParticipant>>>;
  entityType: Scalars['String']['output'];
  /** Класс сущности которой принадлежит чат */
  foreginEntityId: Scalars['ID']['output'];
  /** Тип чата */
  foreginEntityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Последнее сообщение чата */
  lastMessage?: Maybe<ChatMessage>;
  /** Тема чата */
  topic?: Maybe<Scalars['String']['output']>;
  /** ID сущности которой принадлежит чат */
  type?: Maybe<TypeOfChat>;
  /** Непрочитано сообщений */
  unreadMessages?: Maybe<Scalars['Int']['output']>;
};

/** Сообщение чата */
export type ChatMessage = {
  __typename?: 'ChatMessage';
  /** Вывод даты разными способами */
  createdAt?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  /** Файлы */
  files?: Maybe<Array<Maybe<Media>>>;
  id: Scalars['ID']['output'];
  /** Текст */
  text?: Maybe<Scalars['String']['output']>;
  /** Автор */
  user?: Maybe<User>;
};


/** Сообщение чата */
export type ChatMessageCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Участник чата */
export type ChatParticipant = {
  __typename?: 'ChatParticipant';
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Не получать уведомления */
  isMuted?: Maybe<Scalars['Boolean']['output']>;
  /** Вывод даты разными способами */
  joinedAt?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  lastReadAt?: Maybe<Scalars['String']['output']>;
  /** Юзер */
  user?: Maybe<User>;
};


/** Участник чата */
export type ChatParticipantJoinedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Участник чата */
export type ChatParticipantLastReadAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Город */
export type City = {
  __typename?: 'City';
  /** Цена доставки в городе */
  deliveryPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** Признак удаления */
  isDeleted: Scalars['Boolean']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Название EN */
  nameEn: Scalars['String']['output'];
  /** Префектура */
  prefecture?: Maybe<Prefecture>;
};

/** Претензия */
export type Claim = {
  __typename?: 'Claim';
  /** Код претензии */
  code?: Maybe<Scalars['String']['output']>;
  /** Клиент */
  counterparty?: Maybe<Counterparty>;
  /** Вывод даты разными способами */
  createdAt?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Внутренний чат */
  innerChat?: Maybe<Chat>;
  /** Чат с клиентом */
  outerChat?: Maybe<Chat>;
  /** Запчасть */
  part?: Maybe<Part>;
  /** Статус */
  status?: Maybe<Status>;
  /** Вывод даты разными способами */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Авто */
  vehicle?: Maybe<Vehicle>;
};


/** Претензия */
export type ClaimCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Претензия */
export type ClaimUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Фактор стравки комплектации */
export type CommonBidFactor = {
  __typename?: 'CommonBidFactor';
  /** Изменение цены ставки */
  amount: Scalars['Float']['output'];
  /** Блокировать ставку при наличии */
  blockAvailable: Scalars['Boolean']['output'];
  /** Блокировать ставки при отсутствии */
  blockOutStock: Scalars['Boolean']['output'];
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  /** Описание */
  description: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  /** Файлы */
  files?: Maybe<Array<Maybe<Media>>>;
  id: Scalars['ID']['output'];
  /** Тип влияния (plus, minus, equals) */
  influenceType: Scalars['String']['output'];
  /** Признак тюнинга */
  isTuning: Scalars['Boolean']['output'];
  /** Заголовок */
  title: Scalars['String']['output'];
};


/** Фактор стравки комплектации */
export type CommonBidFactorDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Общий фактор доставки */
export type CommonDeliveryFactor = {
  __typename?: 'CommonDeliveryFactor';
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Цена фактора */
  price: Scalars['Float']['output'];
};

export type CommonOutputType = {
  __typename?: 'CommonOutputType';
  /** Признак проблемы */
  isError: Scalars['String']['output'];
  /** Сообщение пользователю */
  message: Scalars['String']['output'];
};

/** Грузополучатель */
export type Consignee = {
  __typename?: 'Consignee';
  /** Адрес получателя */
  address: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** ФИО получателя */
  name: Scalars['String']['output'];
  /** Адрес уведомителя */
  notifyAddress: Scalars['String']['output'];
  /** ФИО уведомителя */
  notifyName: Scalars['String']['output'];
  /** Телефон уведомителя */
  notifyPhone: Scalars['String']['output'];
  /** Телефон получателя */
  phone: Scalars['String']['output'];
};

/** Контейнер */
export type Container = {
  __typename?: 'Container';
  /** BL */
  BL?: Maybe<Array<Maybe<Media>>>;
  /** Букинг контейнера */
  CB?: Maybe<Array<Maybe<Media>>>;
  /** Коносамент */
  CS?: Maybe<Array<Maybe<Media>>>;
  /** Букинг рейса парохода */
  EB?: Maybe<Array<Maybe<Media>>>;
  /** Эскпортный сертификат */
  EC?: Maybe<Array<Maybe<Media>>>;
  /** Экспортная декларация */
  ED?: Maybe<Array<Maybe<Media>>>;
  /** Экспортная инспекция */
  EI?: Maybe<Array<Maybe<Media>>>;
  /** Экспортный инвойс */
  INV?: Maybe<Array<Maybe<Media>>>;
  /** ISF */
  ISF?: Maybe<Array<Maybe<Media>>>;
  /** Упаковочный лист */
  PL?: Maybe<Array<Maybe<Media>>>;
  /** BL с отметкой для выдачи */
  SBL?: Maybe<Array<Maybe<Media>>>;
  /** SI */
  SI?: Maybe<Array<Maybe<Media>>>;
  /** ПТС на ААН */
  aanDocs?: Maybe<Array<Maybe<Media>>>;
  /** Документы с аукциона */
  aucDocs?: Maybe<Array<Maybe<Media>>>;
  /** Брокер */
  broker?: Maybe<Counterparty>;
  /** Перевозчик */
  carrier?: Maybe<Carrier>;
  /** Грузополучатель */
  consignee?: Maybe<Consignee>;
  /** Тип контейнера */
  containerType?: Maybe<TypeOfContainer>;
  /** Клиент */
  counterparty?: Maybe<Counterparty>;
  /** Страна назначения */
  countryDestination?: Maybe<Country>;
  /** Вывод даты разными способами */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  deliveredAt?: Maybe<Scalars['String']['output']>;
  /** Перевозчик документов */
  docCarrier?: Maybe<Counterparty>;
  /** Трекинг документов */
  docTrackingNumber?: Maybe<Scalars['String']['output']>;
  /** Список заказанных ДВС */
  engines?: Maybe<Array<Maybe<ContainerEngine>>>;
  entityType: Scalars['String']['output'];
  /** Экспортный рейс */
  exportTrip?: Maybe<ExportTrip>;
  /** Файлы */
  files?: Maybe<Array<Maybe<Media>>>;
  /** Тип оплаты фрахта */
  freightPaymentType?: Maybe<TypeOfFreight>;
  id: Scalars['ID']['output'];
  /** Букинг клиента */
  is_client_booking?: Maybe<Scalars['Boolean']['output']>;
  /** Список заказанных запчастей */
  parts?: Maybe<Array<Maybe<ContainerPart>>>;
  /** Вывод даты разными способами */
  plannedAt?: Maybe<Scalars['String']['output']>;
  /** Порт назначения */
  portDestination?: Maybe<Port>;
  /** Порт экспорта */
  portExport?: Maybe<Port>;
  /** Продажа */
  sale?: Maybe<Sale>;
  /** Статус */
  status?: Maybe<Status>;
  /** Сток погрузки */
  stock?: Maybe<Stock>;
  /** Накладная погрузки со стока */
  stockInvoice?: Maybe<StockInvoice>;
  /** Номер отслеживания контейнера */
  trackNumber?: Maybe<Scalars['String']['output']>;
  /** Авто */
  vehicle?: Maybe<Vehicle>;
};


/** Контейнер */
export type ContainerCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Контейнер */
export type ContainerDeliveredAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Контейнер */
export type ContainerPlannedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** ДВС заказа в контейнер */
export type ContainerEngine = {
  __typename?: 'ContainerEngine';
  /** Количество */
  count: Scalars['Int']['output'];
  /** Комплектация ДВС */
  engine?: Maybe<EngineEquipment>;
  id: Scalars['ID']['output'];
  /** Список погруженных в контейнер объектов этого класса */
  objects?: Maybe<Array<Maybe<StockInvoiceObject>>>;
};

/** ДВС заказа в контейнер */
export type ContainerPart = {
  __typename?: 'ContainerPart';
  /** Количество */
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Список погруженных в контейнер объектов этого класса */
  objects?: Maybe<Array<Maybe<StockInvoiceObject>>>;
  /** Тип запчасти */
  part?: Maybe<TypeOfGenerationPart>;
};

/** Контрагент */
export type Counterparty = {
  __typename?: 'Counterparty';
  /** KYC контрагента */
  KYC?: Maybe<Kyc>;
  /** Вывод даты разными способами */
  acceptedAucRulesAt?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  acceptedDomesticRulesAt?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  acceptedMetalRulesAt?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  acceptedWWRulesAt?: Maybe<Scalars['String']['output']>;
  /** Адрес */
  address?: Maybe<Scalars['String']['output']>;
  /** Есть ли доступ к торгам */
  allowAuc?: Maybe<Scalars['Boolean']['output']>;
  /** Разрешено ли платить наличными */
  allowCash?: Maybe<Scalars['Boolean']['output']>;
  /** Разрешено ли платить безналичными платежами */
  allowOnlineCash?: Maybe<Scalars['Boolean']['output']>;
  /** Аукционы контрагента */
  auctions?: Maybe<Array<Maybe<Auction>>>;
  /** Список депозитов */
  balances?: Maybe<Array<Maybe<Balance>>>;
  /** Тип Ставки */
  bidType?: Maybe<TypeOfBid>;
  /** Причина блокировки */
  blockReason?: Maybe<Scalars['String']['output']>;
  /** Грузоподъемность грузовика */
  carPayload?: Maybe<Scalars['Float']['output']>;
  /** Номер грузовика */
  carPlate?: Maybe<Scalars['String']['output']>;
  /** Список доставщиков */
  carriers?: Maybe<Array<Maybe<Carrier>>>;
  /** Класс контрагента */
  class?: Maybe<CounterpartyClass>;
  /** Код контрагента */
  code: Scalars['String']['output'];
  /** Контактное лицо */
  contactPerson?: Maybe<Scalars['String']['output']>;
  /** Подчиненные контрагенты */
  counterpaties?: Maybe<Array<Maybe<Counterparty>>>;
  /** Страна контрагента */
  country?: Maybe<Country>;
  /** Список депозитов */
  deposits?: Maybe<Array<Maybe<AucDeposit>>>;
  /** Емейл */
  email?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  /** Наценка контрагента */
  extraCharge: Scalars['Float']['output'];
  /** Факс */
  fax?: Maybe<Scalars['String']['output']>;
  /** Файлы */
  files?: Maybe<Array<Maybe<Media>>>;
  /** Тип оплаты фрахта */
  freightPaymentType?: Maybe<TypeOfFreight>;
  id: Scalars['ID']['output'];
  /** Invoice number */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** Признак активности */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Флаг блокировки */
  isBlocked?: Maybe<Scalars['Boolean']['output']>;
  /** Брокер */
  isBroker?: Maybe<Scalars['Boolean']['output']>;
  /** Перевозчик документов */
  isDocCarrier?: Maybe<Scalars['Boolean']['output']>;
  /** Признак что погашение долгов делается вручную */
  isManualFinance?: Maybe<Scalars['Boolean']['output']>;
  /** Международный перевозчик */
  isWWCarrier?: Maybe<Scalars['Boolean']['output']>;
  /** Главный контрагент */
  mainCounterparty?: Maybe<Counterparty>;
  /** Название контрагента */
  name: Scalars['String']['output'];
  /** Заметки для оплаты контрагенту */
  paymentDetails?: Maybe<Scalars['String']['output']>;
  /** Телефон */
  phone?: Maybe<Scalars['String']['output']>;
  /** Порты контрагента */
  ports?: Maybe<Array<Maybe<CounterpartyPort>>>;
  /** Почтовый индекс */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Контрагент для ресайкла */
  recycleAgent?: Maybe<Counterparty>;
  /** Лицензии ресайкла */
  recycleLicenses?: Maybe<Array<Maybe<RecycleLicense>>>;
  /** Запрсо на регистрацию */
  request?: Maybe<RegistrationRequest>;
  /** Web site */
  site?: Maybe<Scalars['String']['output']>;
  /** Налоговый номер */
  taxNumber?: Maybe<Scalars['String']['output']>;
  /** Грузовики */
  trucks?: Maybe<Array<Maybe<Truck>>>;
  /** Список юзеров контргаента */
  users?: Maybe<Array<Maybe<User>>>;
  /** Ярды */
  yards?: Maybe<Array<Maybe<Yard>>>;
};


/** Контрагент */
export type CounterpartyAcceptedAucRulesAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Контрагент */
export type CounterpartyAcceptedDomesticRulesAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Контрагент */
export type CounterpartyAcceptedMetalRulesAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Контрагент */
export type CounterpartyAcceptedWwRulesAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Класс контрагента */
export type CounterpartyClass = {
  __typename?: 'CounterpartyClass';
  id: Scalars['ID']['output'];
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
};

export type CounterpartyDebt = {
  __typename?: 'CounterpartyDebt';
  /** Контрагент */
  counterparty: Counterparty;
  /** Счета по валюте */
  currencies?: Maybe<Array<Maybe<CounterpartyDebtCurrency>>>;
};

export type CounterpartyDebtAccrual = {
  __typename?: 'CounterpartyDebtAccrual';
  /** Контрагент */
  debtAccrual: DebtAccrual;
  /** Значение */
  isExpiresDebtDate: Scalars['Boolean']['output'];
};

export type CounterpartyDebtCurrency = {
  __typename?: 'CounterpartyDebtCurrency';
  /** Валюта */
  currency: Currency;
  /** Общая текущая задолженность */
  currentDebtAmount?: Maybe<Scalars['Float']['output']>;
  /** Дата крайней отсрочки */
  expireDebtDate?: Maybe<Scalars['String']['output']>;
  /** Сумма просроченной задолженности */
  expiredDebtAmount?: Maybe<Scalars['Float']['output']>;
  /** Просрочен ли срок задолженности */
  isExpiresDebtDate: Scalars['Boolean']['output'];
  /** Дата самого старого долга */
  lastDebtDate?: Maybe<Scalars['String']['output']>;
  /** Лимит задолженности */
  limitDebtAmount?: Maybe<Scalars['Float']['output']>;
  /** Список продаж */
  sales?: Maybe<Array<Maybe<CounterpartyDebtSale>>>;
};

export type CounterpartyDebtSale = {
  __typename?: 'CounterpartyDebtSale';
  /** Размер долга */
  currentDebtAmount?: Maybe<Scalars['Float']['output']>;
  /** Список долгов */
  debts?: Maybe<Array<Maybe<CounterpartyDebtAccrual>>>;
  /** Просрочен срок долга */
  isExpiresDebtDate: Scalars['Boolean']['output'];
  /** Продажа */
  sale: Sale;
};

/** Порт контрагента */
export type CounterpartyPort = {
  __typename?: 'CounterpartyPort';
  id: Scalars['ID']['output'];
  /** Порт импорта */
  port?: Maybe<Port>;
  /** Тип порта для контрагента */
  type?: Maybe<TypeOfPort>;
};

export type CountriesFilterInput = {
  /** Список стран с котнрагентами */
  haveCounterparty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Список стран с портами */
  havePorts?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Страна */
export type Country = {
  __typename?: 'Country';
  /** Код страны */
  alfa2: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Название страны */
  name: Scalars['String']['output'];
  /** Название на английском */
  nameInt: Scalars['String']['output'];
};

export type CountryPagination = {
  __typename?: 'CountryPagination';
  /** Current page of the cursor */
  current_page: Scalars['Int']['output'];
  /** List of items on the current page */
  data: Array<Country>;
  /** Number of the first item returned */
  from?: Maybe<Scalars['Int']['output']>;
  /** Determines if cursor has more pages after the current page */
  has_more_pages: Scalars['Boolean']['output'];
  /** The last page (number of pages) */
  last_page: Scalars['Int']['output'];
  /** Number of items returned per page */
  per_page: Scalars['Int']['output'];
  /** Number of the last item returned */
  to?: Maybe<Scalars['Int']['output']>;
  /** Number of total items selected by the query */
  total: Scalars['Int']['output'];
};

export type CreateCashBankHandedInput = {
  /** Количетсво */
  amount: Scalars['Float']['input'];
  /** ID сотрудника */
  user: Scalars['ID']['input'];
};

export type CreateCashBoxHandedInput = {
  /** Количетсво */
  amount: Scalars['Float']['input'];
  /** ID сотрудника */
  user: Scalars['ID']['input'];
};

export type CreateCashBoxIssueInput = {
  /** Количетсво */
  amount: Scalars['Float']['input'];
  /** ID сотрудника */
  user: Scalars['ID']['input'];
};

export type CreateTaxStickerBoxHandedInput = {
  /** Количетсво */
  count: Scalars['Int']['input'];
  /** ID типа наклейки */
  taxSticker: Scalars['ID']['input'];
  /** ID сотрудника */
  user: Scalars['ID']['input'];
};

export type CreateTaxStickerBoxIssueInput = {
  /** Количетсво */
  count: Scalars['Int']['input'];
  /** ID типа наклейки */
  taxSticker: Scalars['ID']['input'];
  /** ID сотрудника */
  user: Scalars['ID']['input'];
};

/** Валюта */
export type Currency = {
  __typename?: 'Currency';
  /** Код ISO */
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Название */
  name?: Maybe<Scalars['String']['output']>;
  /** Символ */
  symbol?: Maybe<Scalars['String']['output']>;
};

/** Курс валюты */
export type CurrencyRate = {
  __typename?: 'CurrencyRate';
  /** Исходная валюта */
  baseCurrency?: Maybe<Currency>;
  /** Вывод даты разными способами */
  createdAt?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Курс конвертации за 1 единицу исходной валюты */
  rate?: Maybe<Scalars['Float']['output']>;
  /** Вывод даты разными способами */
  rateDate?: Maybe<Scalars['String']['output']>;
  /** Валюта конвертации */
  targetCurrency?: Maybe<Currency>;
};


/** Курс валюты */
export type CurrencyRateCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Курс валюты */
export type CurrencyRateRateDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Начисление долга */
export type DebtAccrual = {
  __typename?: 'DebtAccrual';
  /** Цена товара */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Навальный продукт для разноски дохода */
  bulkProduct?: Maybe<BulkProduct>;
  /** Количество товара */
  count?: Maybe<Scalars['Int']['output']>;
  /** Вывод даты разными способами */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Валюта */
  currency?: Maybe<Currency>;
  /** Долг */
  debt?: Maybe<Scalars['Float']['output']>;
  entityType: Scalars['String']['output'];
  /** ID сущности на которую начисление */
  goodsEntityType: Scalars['String']['output'];
  /** Класс сущности на которую начисление */
  goodsId: Scalars['ID']['output'];
  /** Название сущности на которую начисление */
  goodsName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Форма денег */
  moneyType?: Maybe<TypeOfMoney>;
  /** Плательщик */
  payer?: Maybe<Counterparty>;
  /** Продавец */
  seller?: Maybe<Counterparty>;
  /** Услуга */
  service?: Maybe<Service>;
  /** Налог */
  tax?: Maybe<Scalars['Float']['output']>;
  /** Итого */
  totalAmount?: Maybe<Scalars['Float']['output']>;
  /** Вывод даты разными способами */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Список погашений долга */
  writeOffs?: Maybe<Array<Maybe<BalanceTransaction>>>;
  /** Цена в йенах */
  yenAmount?: Maybe<Scalars['Float']['output']>;
  /** Долг в йенах */
  yenDebt?: Maybe<Scalars['Float']['output']>;
  /** Итого в йенах */
  yenTotalAmount?: Maybe<Scalars['Float']['output']>;
};


/** Начисление долга */
export type DebtAccrualCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Начисление долга */
export type DebtAccrualUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Заявка на доставку авто */
export type Delivery = {
  __typename?: 'Delivery';
  /** Аукцион откуда */
  auction?: Maybe<Auction>;
  /** Доставщик */
  carrier?: Maybe<Carrier>;
  /** Город откуда */
  city?: Maybe<City>;
  /** Цена доставки */
  cost?: Maybe<Scalars['Float']['output']>;
  /** Вывод даты разными способами */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  deliveredAt?: Maybe<Scalars['String']['output']>;
  /** Факторы доставки */
  deliveryFactors?: Maybe<Array<Maybe<DeliveryFactor>>>;
  /** Водитель */
  driver?: Maybe<User>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Признак срочности */
  isUrgent: Scalars['Boolean']['output'];
  /** Заметки */
  notes?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  pickedUpAt?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  plannedAt?: Maybe<Scalars['String']['output']>;
  /** Маршрут доставки */
  route?: Maybe<DeliveryRoute>;
  /** Статус */
  status?: Maybe<Status>;
  /** Тип доставки */
  type?: Maybe<TypeOfDelivery>;
  /** Машина */
  vehicle?: Maybe<Vehicle>;
  /** Ярд откуда */
  yardFrom?: Maybe<Yard>;
  /** Ярд куда */
  yardTo?: Maybe<Yard>;
};


/** Заявка на доставку авто */
export type DeliveryCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Заявка на доставку авто */
export type DeliveryDeliveredAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Заявка на доставку авто */
export type DeliveryPickedUpAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Заявка на доставку авто */
export type DeliveryPlannedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Фактор доставки */
export type DeliveryFactor = {
  __typename?: 'DeliveryFactor';
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Цена фактора */
  price: Scalars['Float']['output'];
};

/** Маршрут доставки с аукциона */
export type DeliveryRoute = {
  __typename?: 'DeliveryRoute';
  /** Аукцион */
  auction?: Maybe<Auction>;
  /** Доставщик */
  carrier?: Maybe<Carrier>;
  /** Минимальное число машин в заказе */
  cars?: Maybe<Scalars['Float']['output']>;
  /** Город вывоза */
  city?: Maybe<City>;
  /** Цена доставки */
  cost?: Maybe<Scalars['Float']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Признак удаления */
  isDeleted: Scalars['Boolean']['output'];
  /** Ярд назначения */
  yard?: Maybe<Yard>;
};

/** Страна рынок ДВС */
export type EngineCountry = {
  __typename?: 'EngineCountry';
  /** Страна */
  country?: Maybe<Country>;
  id: Scalars['ID']['output'];
};

export type EngineDashboard = {
  __typename?: 'EngineDashboard';
  /** Количество в пути */
  awaitingCount?: Maybe<Scalars['Int']['output']>;
  /** Количество в контейнерах */
  containersCount?: Maybe<Scalars['Int']['output']>;
  /** Не хватает */
  deficitCount?: Maybe<Scalars['Int']['output']>;
  /** Машина */
  engine: EngineEquipment;
  /** Количество в локальных резервах */
  localCount?: Maybe<Scalars['Int']['output']>;
  /** Количество на стоке */
  stockCurrentCount?: Maybe<Scalars['Int']['output']>;
  /** Целевое количество */
  stockTargetCount?: Maybe<Scalars['Int']['output']>;
};

/** Комплектация ДВС */
export type EngineEquipment = {
  __typename?: 'EngineEquipment';
  /** Коэффициент от ДВС */
  bidRateEngine?: Maybe<BidRateEngine>;
  /** Соотношение наличие-потребность */
  bidRateEngineLive: Scalars['Float']['output'];
  /** Список стран рынков */
  countries?: Maybe<Array<Maybe<EngineCountry>>>;
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  /** Тип комплектации ДВС */
  engineEquipmentType?: Maybe<TypeOfEngineEquipment>;
  /** Модель ДВС */
  engineModel?: Maybe<EngineModel>;
  entityType: Scalars['String']['output'];
  /** Файлы */
  files?: Maybe<Array<Maybe<Media>>>;
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Название для фронта полное */
  nameFront: Scalars['String']['output'];
  /** Цена продажи */
  salePrice: Scalars['Float']['output'];
  /** Цена продажи scrap */
  scrapAmount: Scalars['Float']['output'];
  /** В распоряжении */
  stockCurrentCount: Scalars['Int']['output'];
  /** Целевое количество */
  stockTargetCount: Scalars['Int']['output'];
  /** Вес */
  weight: Scalars['Float']['output'];
};


/** Комплектация ДВС */
export type EngineEquipmentDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Семейство ДВС */
export type EngineFamily = {
  __typename?: 'EngineFamily';
  /** Тип навального продукта */
  bulkProduct?: Maybe<BulkProduct>;
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  /** Тип топлива */
  fuel?: Maybe<Fuel>;
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Объем ДВС */
  volume: Scalars['Float']['output'];
};


/** Семейство ДВС */
export type EngineFamilyDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EngineHistoryRate = {
  __typename?: 'EngineHistoryRate';
  /** Дата и время */
  date: Scalars['String']['output'];
  /** Значение */
  value: Scalars['Float']['output'];
};

export type EngineHistoryStockCount = {
  __typename?: 'EngineHistoryStockCount';
  /** Дата и время */
  date: Scalars['String']['output'];
  /** Экватор */
  middle?: Maybe<Scalars['Float']['output']>;
  /** В распоряжении */
  stock?: Maybe<Scalars['Float']['output']>;
  /** Целевое значение */
  target?: Maybe<Scalars['Float']['output']>;
};

/** Модель ДВС */
export type EngineModel = {
  __typename?: 'EngineModel';
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  /** Семейство ДВС */
  engineFamily?: Maybe<EngineFamily>;
  entityType: Scalars['String']['output'];
  /** Файлы */
  files?: Maybe<Array<Maybe<Media>>>;
  id: Scalars['ID']['output'];
  /** Ограниченная продажа */
  isLimitedSale: Scalars['Boolean']['output'];
  /** Стоп-лист */
  isStopList: Scalars['Boolean']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Название для фронта полное */
  nameFront: Scalars['String']['output'];
  /** Название в США */
  nameUS: Scalars['String']['output'];
  /** Мощность в лс */
  power?: Maybe<Scalars['Float']['output']>;
  /** Количество турбин */
  turbines: Scalars['Int']['output'];
};


/** Модель ДВС */
export type EngineModelDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Комментарий к сущности */
export type EntityComment = {
  __typename?: 'EntityComment';
  /** Синоним */
  comment: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** Фактор стравки комплектации */
export type EquipmentBidFactor = {
  __typename?: 'EquipmentBidFactor';
  /** Изменение цены ставки */
  amount: Scalars['Float']['output'];
  /** Блокировать ставку при наличии */
  blockAvailable: Scalars['Boolean']['output'];
  /** Блокировать ставки при отсутствии */
  blockOutStock: Scalars['Boolean']['output'];
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  /** Описание */
  description: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  /** Файлы */
  files?: Maybe<Array<Maybe<Media>>>;
  id: Scalars['ID']['output'];
  /** Тип влияния (plus, minus, equals) */
  influenceType: Scalars['String']['output'];
  /** Признак тюнинга */
  isTuning: Scalars['Boolean']['output'];
  /** Комплектация */
  modelEquipment?: Maybe<ModelEquipment>;
  /** Заголовок */
  title: Scalars['String']['output'];
};


/** Фактор стравки комплектации */
export type EquipmentBidFactorDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Статистика ставок комплектации за 30 дней */
export type EquipmentBidStatistic = {
  __typename?: 'EquipmentBidStatistic';
  /** Ставка */
  amount: Scalars['Float']['output'];
  /** Количество ставок */
  bids: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Количество побед */
  wons: Scalars['Int']['output'];
};

/** Навальный продукт комплектации */
export type EquipmentBulkProduct = {
  __typename?: 'EquipmentBulkProduct';
  /** Тип навального продукта */
  bulkProduct?: Maybe<BulkProduct>;
  id: Scalars['ID']['output'];
  /** Комплектация */
  modelEquipment?: Maybe<ModelEquipment>;
  /** Количество */
  quantity: Scalars['Float']['output'];
};

/** Катализатор комплектации */
export type EquipmentCatalyst = {
  __typename?: 'EquipmentCatalyst';
  /** Модель катализатора */
  catalyst?: Maybe<Catalyst>;
  id: Scalars['ID']['output'];
  /** Комплектация */
  modelEquipment?: Maybe<ModelEquipment>;
  /** Количество */
  quantity: Scalars['Int']['output'];
};

export type EquipmentHistoryBid = {
  __typename?: 'EquipmentHistoryBid';
  /** Базовая ставка */
  baseBid?: Maybe<Scalars['Float']['output']>;
  /** Оперативная ставка */
  currentBid?: Maybe<Scalars['Float']['output']>;
  /** Дата и время */
  date: Scalars['String']['output'];
  /** Доход */
  income?: Maybe<Scalars['Float']['output']>;
  /** Максимальная ставка */
  maxBid?: Maybe<Scalars['Float']['output']>;
};

export type EquipmentHistoryLot = {
  __typename?: 'EquipmentHistoryLot';
  /** Дата */
  date: Scalars['String']['output'];
  /** Количество лотов в этот день */
  value: Scalars['Float']['output'];
};

export type EquipmentHistoryLotBidType = {
  __typename?: 'EquipmentHistoryLotBidType';
  /** Ставок */
  bids?: Maybe<Scalars['Float']['output']>;
  /** Дата и время */
  date: Scalars['String']['output'];
  /** Выигрышей */
  wons?: Maybe<Scalars['Float']['output']>;
};

export type EquipmentHistoryRate = {
  __typename?: 'EquipmentHistoryRate';
  /** Дата и время */
  date: Scalars['String']['output'];
  /** Значение */
  value: Scalars['Float']['output'];
};

export type EquipmentHistoryTrade = {
  __typename?: 'EquipmentHistoryTrade';
  /** Средняя сумма ставки */
  bid?: Maybe<Scalars['Float']['output']>;
  /** Дата */
  date: Scalars['String']['output'];
  /** Средняя сумма продажи при поражении */
  sold?: Maybe<Scalars['Float']['output']>;
  /** Средняя сумма выигрыша */
  won?: Maybe<Scalars['Float']['output']>;
};

export type EquipmentIncomeRow = {
  __typename?: 'EquipmentIncomeRow';
  /** Средняя цена продажи */
  averageAmount: Scalars['Float']['output'];
  /** Число продаж */
  count: Scalars['Float']['output'];
  /** Самая высокая цена продажи */
  highAmount: Scalars['Float']['output'];
  /** Самая низкая цена продажи */
  lowAmount: Scalars['Float']['output'];
  /** Продукт */
  name: Scalars['String']['output'];
};

/** Порт экспорта в зависимости от порта импорта */
export type ExportPort = {
  __typename?: 'ExportPort';
  /** Аукцион */
  auction?: Maybe<Auction>;
  /** Страна порта импорта */
  country?: Maybe<Country>;
  entityType: Scalars['String']['output'];
  /** Порт экспорта */
  exportPort?: Maybe<Port>;
  id: Scalars['ID']['output'];
  /** Порт импорта */
  importPort?: Maybe<Port>;
};

/** Рейс экспорта */
export type ExportTrip = {
  __typename?: 'ExportTrip';
  /** Перезвозчик */
  counterparty?: Maybe<Counterparty>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Дата погрузки */
  loadingDate: Scalars['String']['output'];
  /** Название рейса */
  name: Scalars['String']['output'];
  /** Порт погрузки */
  portFrom?: Maybe<Port>;
  /** Порт выгрузки */
  portTo?: Maybe<Port>;
  /** Судно */
  vessel?: Maybe<Vessel>;
};

export type FileOutputType = {
  __typename?: 'FileOutputType';
  uploaded?: Maybe<PreSignedFile>;
};

/** Заявкак на покупку FixPrice */
export type FixPriceRequest = {
  __typename?: 'FixPriceRequest';
  /** Тип покупки */
  bidType?: Maybe<TypeOfBid>;
  /** Город вывоза */
  city?: Maybe<City>;
  /** Комментарий */
  comment?: Maybe<Scalars['String']['output']>;
  /** Клиент */
  counterparty?: Maybe<Counterparty>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Постоянный лот */
  lot?: Maybe<Lot>;
  /** Ставка на постоянный лот */
  lotBid?: Maybe<LotBid>;
  /** Адрес вывоза */
  pickupAddress?: Maybe<Scalars['String']['output']>;
  /** Машина из каталога */
  sharedInventoryCar?: Maybe<CatalogVehicle>;
  /** Грузовик из каталога */
  sharedInventoryTruck?: Maybe<CatalogVehicle>;
  /** Статус заявки */
  status?: Maybe<Status>;
  /** Купленный объект */
  vehicle?: Maybe<Vehicle>;
};

export type ForgotPasswordInput = {
  /** Логин учетной записи */
  login: Scalars['String']['input'];
};

/** Топливо */
export type Fuel = {
  __typename?: 'Fuel';
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Емкость для газа при утилизации */
export type GasTank = {
  __typename?: 'GasTank';
  /** Вывод даты разными способами */
  createdAt?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  /** Вывод даты разными способами */
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Номер бака */
  number: Scalars['String']['output'];
  /** Вывод даты разными способами */
  transferedAt?: Maybe<Scalars['String']['output']>;
  /** Список авто из которых газ в емкости */
  vehicles?: Maybe<Array<Maybe<Vehicle>>>;
  /** Цех разбора */
  workshop?: Maybe<Workshop>;
};


/** Емкость для газа при утилизации */
export type GasTankCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Емкость для газа при утилизации */
export type GasTankFinishedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Емкость для газа при утилизации */
export type GasTankTransferedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Модель КПП */
export type GearboxModel = {
  __typename?: 'GearboxModel';
  /** Список ОЕМ кодов */
  OEMCodes?: Maybe<Array<Maybe<Synonym>>>;
  /** Тип навального продукта */
  bulkProduct?: Maybe<BulkProduct>;
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Цена продажи */
  saleAmount: Scalars['Float']['output'];
  /** Цена продажи scrap */
  scrapAmount: Scalars['Float']['output'];
  /** Тип КПП */
  type?: Maybe<TypeOfGearbox>;
  /** Вес */
  weight: Scalars['Float']['output'];
};


/** Модель КПП */
export type GearboxModelDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Поколение модели */
export type Generation = {
  __typename?: 'Generation';
  /** Марка */
  brand?: Maybe<Brand>;
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  /** Список тиров поколения */
  generationTiers?: Maybe<Array<Maybe<Tier>>>;
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Название для фронта полное */
  nameFront: Scalars['String']['output'];
  /** Год начала производства */
  yearFrom: Scalars['Int']['output'];
  /** Год окончания производства */
  yearTo: Scalars['Int']['output'];
};


/** Поколение модели */
export type GenerationDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Модель */
export type GenerationModel = {
  __typename?: 'GenerationModel';
  /** Базовая ставка для отбора */
  baseBidAmount: Scalars['Float']['output'];
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  /** Поколение */
  generation?: Maybe<Generation>;
  /** Список тиров модели */
  generationModelTiers?: Maybe<Array<Maybe<Tier>>>;
  id: Scalars['ID']['output'];
  /** Привязка модели в в базе знаний */
  lotToGenerationModels?: Maybe<Array<Maybe<LotToGenerationModel>>>;
  /** Название */
  name: Scalars['String']['output'];
  /** Название для фронта полное */
  nameFront: Scalars['String']['output'];
};


/** Модель */
export type GenerationModelDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** KYC контрагента */
export type Kyc = {
  __typename?: 'KYC';
  /** Требуется дополнительная информация от клиента */
  additionalInfo?: Maybe<Scalars['String']['output']>;
  /** Причина отказа */
  declineReason?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  /** Вывод даты разными способами */
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Написать тип импортируемого товара */
  importGoods?: Maybe<Scalars['String']['output']>;
  /** Планируемый объем импорта */
  importScale?: Maybe<Scalars['String']['output']>;
  /** Страна импорта соответствует типичному товару, импортируемому на этот рынок */
  importType?: Maybe<Scalars['String']['output']>;
  /** Транзакция с клиентом разрешена */
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  /** Филиалы компании или банк находятся в стоп-странах или странах высокого риска */
  isBankRisk?: Maybe<Scalars['Boolean']['output']>;
  /** Филиалы компании или банк находятся в стоп-странах или странах высокого риска */
  isBankRiskComment?: Maybe<Scalars['String']['output']>;
  /** Имя клиента проверено по санкционным спискам (OFAC, EU, UN, METI) */
  isClientName?: Maybe<Scalars['Boolean']['output']>;
  /** Имя клиента проверено по санкционным спискам (OFAC, EU, UN, METI) */
  isClientNameComment?: Maybe<Scalars['String']['output']>;
  /** Название компании проверено по санкционным спискам (OFAC, EU, UN, METI) */
  isCompanyName?: Maybe<Scalars['Boolean']['output']>;
  /** Название компании проверено по санкционным спискам (OFAC, EU, UN, METI) */
  isCompanyNameComment?: Maybe<Scalars['String']['output']>;
  /** Страна регистрации клиента и страна импорта совпадают */
  isCountries?: Maybe<Scalars['Boolean']['output']>;
  /** Страна регистрации клиента и страна импорта совпадают */
  isCountriesComment?: Maybe<Scalars['String']['output']>;
  /** Компания относится к странам высокого риска */
  isCountriesRisk?: Maybe<Scalars['Boolean']['output']>;
  /** Компания не зарегистрирована в стоп-странах */
  isCountriesStop?: Maybe<Scalars['Boolean']['output']>;
  /** Страна импорта соответствует типичному товару, импортируемому на этот рынок */
  isCountryImport?: Maybe<Scalars['Boolean']['output']>;
  /** Компания является новой (зарегистрирована менее 3 лет назад) */
  isNewCompany?: Maybe<Scalars['Boolean']['output']>;
  /** Проверить компанию в открытых базах данных */
  isOpenDBComment?: Maybe<Scalars['String']['output']>;
  /** Проверка открытых источников, соцсетей, карт */
  isOpenSourcesComment?: Maybe<Scalars['String']['output']>;
  /** Учредители компании (если информация доступна) */
  isOwners?: Maybe<Scalars['Boolean']['output']>;
  /** Учредители компании (если информация доступна) */
  isOwnersComment?: Maybe<Scalars['String']['output']>;
  /** Если товар идет реэкспортом */
  isReexport?: Maybe<Scalars['Boolean']['output']>;
  /** Если товар идет реэкспортом */
  isReexportComment?: Maybe<Scalars['String']['output']>;
  /** Проверено, зарегистрированы ли по этому же адресу другие компании */
  isSharedAddress?: Maybe<Scalars['Boolean']['output']>;
  /** Проверено, зарегистрированы ли по этому же адресу другие компании */
  isSharedAddressComment?: Maybe<Scalars['String']['output']>;
  /** Если у компании есть веб-сайт — проверено ли соответствие сайта заявленному бизнесу */
  isWeb?: Maybe<Scalars['Boolean']['output']>;
  /** Если у компании есть веб-сайт — проверено ли соответствие сайта заявленному бизнесу */
  isWebComment?: Maybe<Scalars['String']['output']>;
  /** Кто завершил проверку */
  user?: Maybe<User>;
};


/** KYC контрагента */
export type KycFinishedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Язык */
export type Language = {
  __typename?: 'Language';
  id: Scalars['ID']['output'];
  /** Код языка */
  iso?: Maybe<LanguageEnum>;
  /** Название языка */
  name: Scalars['String']['output'];
};

/** Enum языков */
export enum LanguageEnum {
  En = 'EN',
  Jp = 'JP',
  Ru = 'RU'
}

/** Событие истории */
export type LogEvent = {
  __typename?: 'LogEvent';
  /** Вывод даты разными способами */
  changedAt?: Maybe<Scalars['String']['output']>;
  /** Изменения */
  changes: Scalars['String']['output'];
  /** Тип лога */
  event: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Тип события */
  message: Scalars['String']['output'];
  /** Мета информация */
  meta: Scalars['String']['output'];
  /** Пользователь */
  user?: Maybe<User>;
};


/** Событие истории */
export type LogEventChangedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Лот торгов */
export type Lot = {
  __typename?: 'Lot';
  /** Аукцион */
  auction?: Maybe<LotAuction>;
  /** Дата и время аукциона (в timezone Asia/Tokyo) */
  auctionDatetime?: Maybe<Scalars['String']['output']>;
  /** Ссылка на аукционный лист */
  auctionListUrl?: Maybe<Scalars['String']['output']>;
  /** Перевод лота переводчиком */
  auctionSheetHumanTranslation?: Maybe<Scalars['String']['output']>;
  /** Озвучка перевода лота переводчиком EN */
  auctionSheetHumanTranslationVoiceEN?: Maybe<Media>;
  /** Озвучка перевода лота переводчиком RU */
  auctionSheetHumanTranslationVoiceRU?: Maybe<Media>;
  /** Перевод лота ИИ */
  auctionSheetOCRTranslation?: Maybe<Scalars['String']['output']>;
  /** Озвучка перевода лота ИИ EN */
  auctionSheetOCRTranslationVoiceEN?: Maybe<Media>;
  /** Озвучка перевода лота ИИ RU */
  auctionSheetOCRTranslationVoiceRU?: Maybe<Media>;
  /** Список ставок на лот */
  bids?: Maybe<Array<Maybe<LotBid>>>;
  /** Марка */
  brand?: Maybe<LotBrand>;
  /** Город вывоза */
  city?: Maybe<City>;
  /** Цвет лота */
  color?: Maybe<LotColor>;
  /** Объем двигателя */
  engineVolume?: Maybe<Scalars['Int']['output']>;
  entityType: Scalars['String']['output'];
  /** Файлы */
  files?: Maybe<Array<Maybe<Media>>>;
  /** Номер кузова */
  frame: Scalars['String']['output'];
  /** КПП лота */
  gearboxType?: Maybe<LotGearboxClass>;
  /** Комплепктация лота */
  grade?: Maybe<LotGrade>;
  id: Scalars['ID']['output'];
  /** Фото */
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Описание */
  info?: Maybe<Scalars['String']['output']>;
  /** Описание лота оригинальное */
  infoOriginal?: Maybe<Scalars['String']['output']>;
  /** Перевод описания лота */
  infoTranslated?: Maybe<Scalars['String']['output']>;
  /** Флаг доступен ли заказ отсмотра */
  isAucReviewAvaiableAAN: Scalars['Boolean']['output'];
  /** Флаг доступен ли заказ отсмотра */
  isAucReviewAvaiableClient: Scalars['Boolean']['output'];
  /** Флаг что торги аукционист пропустил */
  isMissedTrade: Scalars['Boolean']['output'];
  /** Переговоры доступны */
  isNegotiationsAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Переговоры завершены */
  isNegotiationsFinished?: Maybe<Scalars['Boolean']['output']>;
  /** Переговоры начаты */
  isNegotiationsStarted?: Maybe<Scalars['Boolean']['output']>;
  /** Приоритетный к торгам лот */
  isPriority: Scalars['Boolean']['output'];
  /** Флаг продан ли лот */
  isPurchased: Scalars['Boolean']['output'];
  /** Флаг стоит ли лот на колокольчике */
  isTradeAlert: Scalars['Boolean']['output'];
  /** Номер лота */
  lotNumber: Scalars['String']['output'];
  /** Производитель */
  manufacturer?: Maybe<LotManufacturer>;
  /** Максимальная неснятая ставка */
  maxBid?: Maybe<LotBid>;
  /** Пробег */
  mileage?: Maybe<Scalars['Int']['output']>;
  /** Модель */
  model?: Maybe<LotModel>;
  /** Заголовок для списка */
  nameFront: Scalars['String']['output'];
  /** Старт переговоров */
  negotiationsStart?: Maybe<Scalars['Int']['output']>;
  /** Мощность двигателя */
  power?: Maybe<Scalars['String']['output']>;
  /** Средняя цена */
  priceAverage?: Maybe<Scalars['Int']['output']>;
  /** Итоговая цена */
  priceFinish?: Maybe<Scalars['Int']['output']>;
  /** Стартовая цена */
  priceStart?: Maybe<Scalars['Int']['output']>;
  /** Раздел аукциона */
  range?: Maybe<LotRange>;
  /** Оценка */
  rate?: Maybe<LotRate>;
  /** Файлы */
  reviewFiles?: Maybe<Array<Maybe<Media>>>;
  /** Флаг запрошен ли осмотр на аукционе */
  reviewRequested: Scalars['Boolean']['output'];
  /** Флаг запрошен ли осмотр на аукционе для показа клиенту */
  reviewRequestedForClient: Scalars['Boolean']['output'];
  /** Осмотрщик лота */
  reviewer?: Maybe<User>;
  /** Статус лота */
  status?: Maybe<LotStatus>;
  /** Переводчик лота */
  translater?: Maybe<User>;
  /** Трансмиссия лота */
  transmission?: Maybe<TypeOfLotTrasmission>;
  /** Аукционист торгующий лот */
  user?: Maybe<User>;
  /** Авто */
  vehicle?: Maybe<Vehicle>;
  /** Год */
  year?: Maybe<Scalars['Int']['output']>;
};


/** Лот торгов */
export type LotAuctionDatetimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Аукцион лота */
export type LotAuction = {
  __typename?: 'LotAuction';
  id: Scalars['ID']['output'];
  /** Аукцион базы знаний */
  knowAuction?: Maybe<Auction>;
  /** Название из лота */
  name: Scalars['String']['output'];
};

/** Ставка на лот */
export type LotBid = {
  __typename?: 'LotBid';
  /** Сотрудник на аукционе */
  aucEmployee?: Maybe<User>;
  /** Аукционист */
  auctioneer?: Maybe<User>;
  /** Ставка */
  bidAmount?: Maybe<Scalars['Float']['output']>;
  /** Вывод даты разными способами */
  bidDate?: Maybe<Scalars['String']['output']>;
  /** Группа ставки */
  bidGroup?: Maybe<BidGroup>;
  /** Минимум надо добавить к ставке для шанса на победу */
  bidShift?: Maybe<Scalars['Float']['output']>;
  /** Аукционист кто подтвердил ставку на автомат */
  checker?: Maybe<User>;
  /** Комментарий */
  comment?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  /** Тип оплаты фрахта */
  freightPaymentType?: Maybe<TypeOfFreight>;
  id: Scalars['ID']['output'];
  /** Аукционист кто внес ставку на автомат */
  inputer?: Maybe<User>;
  /** Запрос на снятие ставки */
  isCancelRequest: Scalars['Boolean']['output'];
  /** Признак что ставка торгуется вручную */
  isManualTrade: Scalars['Boolean']['output'];
  /** Победитель */
  isWinner: Scalars['Boolean']['output'];
  /** Лот */
  lot?: Maybe<Lot>;
  /** Порт доставки */
  port?: Maybe<Port>;
  /** Тип отправки */
  shippingType?: Maybe<TypeOfPort>;
  /** Статус ставки */
  status?: Maybe<LotBidStatus>;
  /** Тип ставки */
  type?: Maybe<TypeOfBid>;
  /** Автор ставки */
  user?: Maybe<User>;
};


/** Ставка на лот */
export type LotBidBidDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Статус ставки */
export type LotBidStatus = {
  __typename?: 'LotBidStatus';
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Стастистика работы аукционистов за период */
export type LotBidsTradeStatisticOutput = {
  __typename?: 'LotBidsTradeStatisticOutput';
  /** Назначено для ручных торгов лотов всего */
  assignedCount?: Maybe<Scalars['Float']['output']>;
  /** Назначено для авто торгов лотов всего */
  autoCount?: Maybe<Scalars['Float']['output']>;
  /** Количество пропущенных торгов */
  missCount?: Maybe<Scalars['Float']['output']>;
  /** Количество доступных переговоров */
  negotiationsCount?: Maybe<Scalars['Float']['output']>;
  /** Количество начатых переговоров */
  negotiationsStartCount?: Maybe<Scalars['Float']['output']>;
  /** Количество побед в переговорах */
  negotiationsWonCount?: Maybe<Scalars['Float']['output']>;
  /** Стастистика работы аукционистов */
  users?: Maybe<Array<Maybe<LotBidsTradeStatisticUserOutput>>>;
  /** Количество побед в живых торгах */
  wonsCount?: Maybe<Scalars['Float']['output']>;
};

/** Стастистика работы аукциониста */
export type LotBidsTradeStatisticUserOutput = {
  __typename?: 'LotBidsTradeStatisticUserOutput';
  /** Назначено для ручных торгов лотов всего */
  assignedCount?: Maybe<Scalars['Float']['output']>;
  /** Доля от назначенных за период */
  assignedPercent?: Maybe<Scalars['Float']['output']>;
  /** Количество проверенных лотов на автомат */
  checkedCount?: Maybe<Scalars['Float']['output']>;
  /** Доля от всех проверок за период */
  checkedPercent?: Maybe<Scalars['Float']['output']>;
  /** Количество введенных лотов на автомат */
  inputedCount?: Maybe<Scalars['Float']['output']>;
  /** Доля от всех введенных за период */
  inputedPercent?: Maybe<Scalars['Float']['output']>;
  /** Количество пропущенных торгов */
  missCount?: Maybe<Scalars['Float']['output']>;
  /** % пропущенных торгов */
  missPercent?: Maybe<Scalars['Float']['output']>;
  /** Доля от всех пропущенных торгов */
  missPercentTotal?: Maybe<Scalars['Float']['output']>;
  /** Количество побед в переговорах */
  negotiationsCount?: Maybe<Scalars['Float']['output']>;
  /** % побед в переговорах */
  negotiationsPercent?: Maybe<Scalars['Float']['output']>;
  /** Аукционист */
  user?: Maybe<User>;
  /** Количество побед в живых торгах */
  wonsCount?: Maybe<Scalars['Float']['output']>;
  /** % побед в живых торгах */
  wonsPercent?: Maybe<Scalars['Float']['output']>;
};

/** Марка лота */
export type LotBrand = {
  __typename?: 'LotBrand';
  /** Марка в в базе знаний */
  brand?: Maybe<Brand>;
  id: Scalars['ID']['output'];
  /** Производитель лота */
  lotManufacturer?: Maybe<LotManufacturer>;
  /** Название */
  name: Scalars['String']['output'];
  /** Название для фронта полное */
  nameFront: Scalars['String']['output'];
};

/** Цвет лота */
export type LotColor = {
  __typename?: 'LotColor';
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Статистика обработки дампа лотов */
export type LotDump = {
  __typename?: 'LotDump';
  /** У лота уже есть лот отбора */
  alreadyExists?: Maybe<Scalars['Int']['output']>;
  /** Никогда не ставить - ссылка на лотоы с фильтром день (по старту) и статусу (3) */
  bidNever?: Maybe<Scalars['Int']['output']>;
  /** Вывод даты разными способами */
  completedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Добавлено в базу */
  jpCenterAdded?: Maybe<Scalars['Int']['output']>;
  /** Помечено для удаления лотов в базе */
  jpCenterDeleted?: Maybe<Scalars['Int']['output']>;
  /** Обновлено лотов в базе */
  jpCenterUpdated?: Maybe<Scalars['Int']['output']>;
  /** Лот не найден */
  lotNotFound?: Maybe<Scalars['Int']['output']>;
  /** Нет аукциона - ссылка на лотоы с фильтром день (по старту) и статусу (1) */
  noAuction?: Maybe<Scalars['Int']['output']>;
  /** Нет раздела аукциона - ссылка на лотоы с фильтром день (по старту) и статусу (2) */
  noAuctionRange?: Maybe<Scalars['Int']['output']>;
  /** Отобрано для мясорубки */
  selectionStartedCount?: Maybe<Scalars['Int']['output']>;
  /** Ставка ниже старта - ссылка на лотоы с фильтром день (по старту) и статусу (5) */
  startFail?: Maybe<Scalars['Int']['output']>;
  /** Вывод даты разными способами */
  startedAt?: Maybe<Scalars['String']['output']>;
  /** Стоп-лист - ссылка на лотоы с фильтром день (по старту) и статусу (6) */
  stopList?: Maybe<Scalars['Int']['output']>;
  /** Отправлено на верификацию - ссылка на лотоы с фильтром день (по старту) и статусу (7) */
  verification?: Maybe<Scalars['Int']['output']>;
};


/** Статистика обработки дампа лотов */
export type LotDumpCompletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Статистика обработки дампа лотов */
export type LotDumpStartedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** КПП лота */
export type LotGearboxClass = {
  __typename?: 'LotGearboxClass';
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Комплектация лота */
export type LotGrade = {
  __typename?: 'LotGrade';
  id: Scalars['ID']['output'];
  /** Модель лота */
  model?: Maybe<LotModel>;
  /** Комплектация в в базе знаний */
  modelEquipment?: Maybe<ModelEquipment>;
  /** Название */
  name: Scalars['String']['output'];
};

/** Производитель лота */
export type LotManufacturer = {
  __typename?: 'LotManufacturer';
  id: Scalars['ID']['output'];
  /** Производитель в в базе знаний */
  manufacturer?: Maybe<Manufacturer>;
  /** Название */
  name: Scalars['String']['output'];
  /** Название для фронта полное */
  nameFront: Scalars['String']['output'];
};

/** Модель марки в лоте (без расширения) */
export type LotModel = {
  __typename?: 'LotModel';
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Марка лота */
  lotBrand?: Maybe<LotBrand>;
  /** Кмоплектации лота */
  lotGrades?: Maybe<Array<Maybe<LotGrade>>>;
  /** Привязка модели в в базе знаний */
  lotToGenerationModels?: Maybe<Array<Maybe<LotToGenerationModel>>>;
  /** Название */
  name: Scalars['String']['output'];
  /** Название для фронта полное */
  nameFront: Scalars['String']['output'];
};

/** Раздел аукциона */
export type LotRange = {
  __typename?: 'LotRange';
  /** Аукцион */
  auction?: Maybe<Auction>;
  /** Город базовый */
  city?: Maybe<City>;
  /** Цена доставки */
  deliveryPrice: Scalars['Float']['output'];
  /** Описание */
  desc: Scalars['String']['output'];
  /** Количество цифр в номере лота */
  digitsCount?: Maybe<Scalars['Int']['output']>;
  /** Начальные цифры номера лота */
  digitsStart?: Maybe<Scalars['Int']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Правило по цифрам (иначе просто диапазон) */
  isDigits: Scalars['Boolean']['output'];
  /** Признак что учитывается в расчетах */
  isEnabled: Scalars['Boolean']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Конец диапазона лотов */
  rangeEnd?: Maybe<Scalars['Int']['output']>;
  /** Начало диапазона лотов */
  rangeStart?: Maybe<Scalars['Int']['output']>;
  /** Ставить всегда */
  ruleBidForever: Scalars['Boolean']['output'];
  /** Никогда не ставить */
  ruleBidNever: Scalars['Boolean']['output'];
  /** Адрес ярда для забора авто */
  yardAddress?: Maybe<Scalars['String']['output']>;
};

/** Оценка лота */
export type LotRate = {
  __typename?: 'LotRate';
  id: Scalars['ID']['output'];
  /** Лоты с такой оценкой приобретаем */
  isBuy: Scalars['Boolean']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Лот отбора */
export type LotSelection = {
  __typename?: 'LotSelection';
  /** Ставка после расчета факторов */
  bidAmount?: Maybe<Scalars['Float']['output']>;
  /** Вывод даты разными способами */
  checkedAt?: Maybe<Scalars['String']['output']>;
  /** Проверяющий */
  checker?: Maybe<User>;
  /** Комментарии */
  comment?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Верификатор ошибся */
  isMistake: Scalars['Boolean']['output'];
  /** Лот */
  lot?: Maybe<Lot>;
  /** Ставка по лоту отбора */
  lotBid?: Maybe<LotBid>;
  /** Факторы ставки */
  lotSelectionBidFactors?: Maybe<Array<Maybe<LotSelectionBidFactor>>>;
  /** Комлпектация модели поколения */
  modelEquipment?: Maybe<ModelEquipment>;
  /** Статус */
  status?: Maybe<LotSelectionStatus>;
  /** Верификатор */
  user?: Maybe<User>;
  /** Вывод даты разными способами */
  verifiedAt?: Maybe<Scalars['String']['output']>;
};


/** Лот отбора */
export type LotSelectionCheckedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Лот отбора */
export type LotSelectionVerifiedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Фактор стравки лота отбора */
export type LotSelectionBidFactor = {
  __typename?: 'LotSelectionBidFactor';
  /** Изменение цены ставки */
  amount: Scalars['Float']['output'];
  /** Блокировать ставку при наличии */
  blockAvailable: Scalars['Boolean']['output'];
  /** Блокировать ставки при отсутствии */
  blockOutStock: Scalars['Boolean']['output'];
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  /** Описание */
  description: Scalars['String']['output'];
  /** Файлы */
  files?: Maybe<Array<Maybe<Media>>>;
  id: Scalars['ID']['output'];
  /** Тип влияния (plus, minus, equals) */
  influenceType: Scalars['String']['output'];
  /** Наличие фактора */
  isChecked?: Maybe<Scalars['Boolean']['output']>;
  /** Признак тюнинга */
  isTuning: Scalars['Boolean']['output'];
  /** Заголовок */
  title: Scalars['String']['output'];
};


/** Фактор стравки лота отбора */
export type LotSelectionBidFactorDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Стаутс лота отбора */
export type LotSelectionStatus = {
  __typename?: 'LotSelectionStatus';
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Стастистика работы верификаторов за период */
export type LotSelectionsStatisticOutput = {
  __typename?: 'LotSelectionsStatisticOutput';
  /** Одобрено лотов всего */
  approvedCount?: Maybe<Scalars['Float']['output']>;
  /** Одобрено лотов от отобранных */
  approvedPercent?: Maybe<Scalars['Float']['output']>;
  /** Проверено отклоненных лотов всего */
  checkedCount?: Maybe<Scalars['Float']['output']>;
  /** Проверено лотов от отклоненных */
  checkedPercent?: Maybe<Scalars['Float']['output']>;
  /** Отложено лотов */
  delayCount?: Maybe<Scalars['Float']['output']>;
  /** Ошибок отбора всего */
  errorsCount?: Maybe<Scalars['Float']['output']>;
  /** Ошибок отбора от отклоненных */
  errorsPercent?: Maybe<Scalars['Float']['output']>;
  /** Пропущено лотов всего */
  missedCount?: Maybe<Scalars['Float']['output']>;
  /** Пропущено лотов от отобранных */
  missedPercent?: Maybe<Scalars['Float']['output']>;
  /** Отклонено лотов всего */
  rejectedCount?: Maybe<Scalars['Float']['output']>;
  /** Отклонено лотов от отобранных */
  rejectedPercent?: Maybe<Scalars['Float']['output']>;
  /** Осталось проверить лотов */
  remainCount?: Maybe<Scalars['Float']['output']>;
  /** Отобрано лотов */
  selectedCount?: Maybe<Scalars['Float']['output']>;
  /** Стастистика работы верификатора */
  users?: Maybe<Array<Maybe<LotSelectionsStatisticUserOutput>>>;
  /** Верифицировано лотов всего */
  verifiedCount?: Maybe<Scalars['Float']['output']>;
  /** Верифицировано лотов от отобранных */
  verifiedPercent?: Maybe<Scalars['Float']['output']>;
};

/** Стастистика работы верификатора */
export type LotSelectionsStatisticUserOutput = {
  __typename?: 'LotSelectionsStatisticUserOutput';
  /** Количество проверенных лотов */
  checkedCount?: Maybe<Scalars['Float']['output']>;
  /** Доля от всех проверок за период */
  checkedPercent?: Maybe<Scalars['Float']['output']>;
  /** Количество ошибок */
  errorsCount?: Maybe<Scalars['Float']['output']>;
  /** % ошибок при верификации */
  errorsPercent?: Maybe<Scalars['Float']['output']>;
  /** Доля от всех ошибок за период */
  errorsPercentTotal?: Maybe<Scalars['Float']['output']>;
  /** Аукционист */
  user?: Maybe<User>;
  /** Верифицировано лотов всего */
  verifiedCount?: Maybe<Scalars['Float']['output']>;
  /** Доля от верифицированных за период */
  verifiedPercent?: Maybe<Scalars['Float']['output']>;
};

/** Лот статистики */
export type LotStatistic = {
  __typename?: 'LotStatistic';
  /** Аукцион */
  auction?: Maybe<LotAuction>;
  /** Дата и время аукциона (в timezone Asia/Tokyo) */
  auctionDatetime?: Maybe<Scalars['String']['output']>;
  /** Ссылка на аукционный лист */
  auctionListUrl?: Maybe<Scalars['String']['output']>;
  /** Марка */
  brand?: Maybe<LotBrand>;
  /** Цвет лота */
  color?: Maybe<LotColor>;
  /** Объем двигателя */
  engineVolume?: Maybe<Scalars['Int']['output']>;
  /** Номер кузова */
  frame: Scalars['String']['output'];
  /** КПП лота */
  gearboxType?: Maybe<LotGearboxClass>;
  /** Комплепктация лота */
  grade?: Maybe<LotGrade>;
  id: Scalars['ID']['output'];
  /** Фото */
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Описание */
  info?: Maybe<Scalars['String']['output']>;
  /** Номер лота */
  lotNumber: Scalars['String']['output'];
  /** Производитель */
  manufacturer?: Maybe<LotManufacturer>;
  /** Пробег */
  mileage?: Maybe<Scalars['Int']['output']>;
  /** Модель */
  model?: Maybe<LotModel>;
  /** Мощность двигателя */
  power?: Maybe<Scalars['Float']['output']>;
  /** Средняя цена */
  priceAverage?: Maybe<Scalars['Int']['output']>;
  /** Итоговая цена */
  priceFinish?: Maybe<Scalars['Int']['output']>;
  /** Стартовая цена */
  priceStart?: Maybe<Scalars['Int']['output']>;
  /** Оценка */
  rate: Scalars['String']['output'];
  /** Трансмиссия лота */
  transmission?: Maybe<TypeOfLotTrasmission>;
  /** Год */
  year?: Maybe<Scalars['Int']['output']>;
};


/** Лот статистики */
export type LotStatisticAuctionDatetimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Стастистика по пробегу в рамках оценки */
export type LotStatisticMileage = {
  __typename?: 'LotStatisticMileage';
  /** Средняя стоимость */
  average: Scalars['Float']['output'];
  /** До для фильтра */
  end: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Название для фильтра */
  name: Scalars['String']['output'];
  /** От для фильтра */
  start: Scalars['String']['output'];
};

/** Статсистика по оценкам в рамках года */
export type LotStatisticRate = {
  __typename?: 'LotStatisticRate';
  /** Средняя стоимость */
  average: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Статистика по пробегам в рамках года */
  mileages: Array<LotStatisticMileage>;
  /** Оценка */
  rate: Scalars['String']['output'];
};

/** Статистика по производителю, марке и году */
export type LotStatisticYear = {
  __typename?: 'LotStatisticYear';
  /** Средняя стоимость */
  average: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Статистика по оценка в рамках года */
  rates: Array<LotStatisticRate>;
  /** Год */
  year: Scalars['String']['output'];
};

/** Стаутс лота */
export type LotStatus = {
  __typename?: 'LotStatus';
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Привязка модели в в базе знаний */
export type LotToGenerationModel = {
  __typename?: 'LotToGenerationModel';
  /** Модель в в базе знаний */
  generationModel?: Maybe<GenerationModel>;
  id: Scalars['ID']['output'];
  /** Модель в в аукционах */
  lotModel?: Maybe<LotModel>;
};

/** Производитель */
export type Manufacturer = {
  __typename?: 'Manufacturer';
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Популярная */
  isPopular: Scalars['Boolean']['output'];
  /** Список производителей лота */
  lotManufacturers?: Maybe<Array<Maybe<LotManufacturer>>>;
  /** Название международное */
  nameEn: Scalars['String']['output'];
  /** Название японское */
  nameJp: Scalars['String']['output'];
};


/** Производитель */
export type ManufacturerDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Медиа\Файл */
export type Media = {
  __typename?: 'Media';
  collectionName?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  created?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  /** Создатель */
  fileType?: Maybe<TypeOfFile>;
  id: Scalars['ID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderColumn?: Maybe<Scalars['Int']['output']>;
  originalUrl?: Maybe<Scalars['String']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  /** Размер */
  size?: Maybe<Scalars['Int']['output']>;
  /** Создатель */
  user?: Maybe<User>;
};


/** Медиа\Файл */
export type MediaCreatedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Комплектация модели */
export type ModelEquipment = {
  __typename?: 'ModelEquipment';
  /** Число аирбэгов */
  airbagsCount: Scalars['Int']['output'];
  /** Возврат за аирбэги */
  airbagsRefundAmount: Scalars['Float']['output'];
  /** Минимальная базовая ставка */
  baseBidAmount: Scalars['Float']['output'];
  /** Список факторов ставок */
  bidFactors?: Maybe<Array<Maybe<EquipmentBidFactor>>>;
  /** Коэффициент от лотов и торгов */
  bidRateLot?: Maybe<BidRateLot>;
  /** Соотношение победы-ставки */
  bidRateLotLive: Scalars['Float']['output'];
  /** Тип Ставки */
  bidType?: Maybe<TypeOfBid>;
  /** Список навальных продуктов */
  bulkProducts?: Maybe<Array<Maybe<EquipmentBulkProduct>>>;
  /** Список катализаторов */
  catalysts?: Maybe<Array<Maybe<EquipmentCatalyst>>>;
  /** Оперативная базовая ставка */
  currentBidAmount: Scalars['Float']['output'];
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  /** ДВС */
  engine?: Maybe<EngineEquipment>;
  entityType: Scalars['String']['output'];
  /** Статистика ставок за 30 дней */
  equipmentBidStatistic?: Maybe<Array<Maybe<EquipmentBidStatistic>>>;
  /** Список индивидуальных запчастей комплектации для типового разбора */
  equipmentDismantles?: Maybe<Array<Maybe<TypeOfGenerationPart>>>;
  /** Файлы */
  files?: Maybe<Array<Maybe<Media>>>;
  /** КПП */
  gearbox?: Maybe<GearboxModel>;
  id: Scalars['ID']['output'];
  /** Прибыль от комплектации */
  incomeAmount: Scalars['Float']['output'];
  /** Доход от ДВС */
  incomeEngineAmount: Scalars['Float']['output'];
  /** Доход от КПП */
  incomeGearboxAmount: Scalars['Float']['output'];
  /** % дохода от комплектации */
  incomeRate: Scalars['Float']['output'];
  /** Признак фиксированной максимальной ставки */
  isFixedMaxBid: Scalars['Boolean']['output'];
  /** Признак стоп-листа */
  isStopList: Scalars['Boolean']['output'];
  /** Признак покупки для продажи в Штаты */
  isUSPriority: Scalars['Boolean']['output'];
  /** Признак безлимитной максимальной ставки */
  isUnlimitedMaxBid: Scalars['Boolean']['output'];
  /** Список комплектаций лота */
  lotGrades?: Maybe<Array<Maybe<LotGrade>>>;
  /** Код производителя */
  manufacturerCode?: Maybe<Scalars['String']['output']>;
  /** Максимальная базовая ставка */
  maxBidAmount: Scalars['Float']['output'];
  /** Модель */
  model?: Maybe<GenerationModel>;
  /** Название */
  name: Scalars['String']['output'];
  /** Название для фронта полное */
  nameFront: Scalars['String']['output'];
  /** Приоритет покупки */
  priority: Scalars['Int']['output'];
  /** Месяц и год окончания выпуска (mm.yyyy) */
  productionEnd: Scalars['String']['output'];
  /** Месяц и год начала выпуска (mm.yyyy) */
  productionStart: Scalars['String']['output'];
  /** Тир */
  tier?: Maybe<Tier>;
  /** Трансмиссия */
  transmission?: Maybe<Transmission>;
};


/** Комплектация модели */
export type ModelEquipmentDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MoveToYard = {
  __typename?: 'MoveToYard';
  /** Дата и время (выводить время HH:MM) */
  date: Scalars['String']['output'];
  /** Кто принял */
  user: User;
  /** Машина */
  vehicle: Vehicle;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Сдача наличных в банк */
  CreateCashBankIssue?: Maybe<Scalars['Boolean']['output']>;
  /** Сдача наличных в кассу */
  CreateCashBoxHanded?: Maybe<Scalars['Boolean']['output']>;
  /** Выдача наличных в подотчет */
  CreateCashBoxIssue?: Maybe<Scalars['Boolean']['output']>;
  /** Потратить наличные подотчет в расходы ААН */
  CreateCashSpend?: Maybe<Scalars['Boolean']['output']>;
  /** Сдача наклеек в офис */
  CreateTaxStickerBoxHanded?: Maybe<Scalars['Boolean']['output']>;
  /** Выдача наклеек в подотчет */
  CreateTaxStickerBoxIssue?: Maybe<Scalars['Boolean']['output']>;
  /** Напомнить пароль */
  ForgotPassword?: Maybe<Scalars['Boolean']['output']>;
  /** Обновить токен */
  RefreshToken: RefreshToken;
  /** Создание заявки на регистрацию международного физического лица */
  RegistrationRequestForeignIndividualUpdate?: Maybe<Scalars['Boolean']['output']>;
  /** Создание заявки на регистрацию международного юридического лица */
  RegistrationRequestForeignLegalEntityUpdate?: Maybe<Scalars['Boolean']['output']>;
  /** Создание заявки на регистрацию японского физического лица */
  RegistrationRequestJapanIndividualUpdate?: Maybe<Scalars['Boolean']['output']>;
  /** Создание заявки на регистрацию японского юридического лица */
  RegistrationRequestJapanLegalEntityUpdate?: Maybe<Scalars['Boolean']['output']>;
  /** Создание заявки на регистрацию поставщика */
  RegistrationRequestVendorUpdate?: Maybe<Scalars['Boolean']['output']>;
  /** Сбросить пароль */
  ResetPassword?: Maybe<Scalars['Boolean']['output']>;
  /** Авторизация */
  SignIn: User;
  /** Сменить пароль */
  UserChangePassword?: Maybe<Scalars['Boolean']['output']>;
  /** Убрать привязку TG */
  UserRemoveTelegram?: Maybe<Scalars['Boolean']['output']>;
  /** Изменить параметр получения уведомления для пользователя */
  UserUpdateNotificationSetting?: Maybe<Scalars['Boolean']['output']>;
  /** Обновление профиля учетной записи */
  UserUpdateProfile?: Maybe<Scalars['Boolean']['output']>;
  /** Обновление аватарки у учетной записи */
  UserUpdateUserpic?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationCreateCashBankIssueArgs = {
  input: CreateCashBankHandedInput;
};


export type MutationCreateCashBoxHandedArgs = {
  input: CreateCashBoxHandedInput;
};


export type MutationCreateCashBoxIssueArgs = {
  input: CreateCashBoxIssueInput;
};


export type MutationCreateCashSpendArgs = {
  input: CreateCashBankHandedInput;
};


export type MutationCreateTaxStickerBoxHandedArgs = {
  input: CreateTaxStickerBoxHandedInput;
};


export type MutationCreateTaxStickerBoxIssueArgs = {
  input: CreateTaxStickerBoxIssueInput;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationRefreshTokenArgs = {
  input: RefreshTokenInput;
};


export type MutationRegistrationRequestForeignIndividualUpdateArgs = {
  input: RegistrationRequestForeignIndividualUpdateInput;
};


export type MutationRegistrationRequestForeignLegalEntityUpdateArgs = {
  input: RegistrationRequestForeignLegalEntityUpdateInput;
};


export type MutationRegistrationRequestJapanIndividualUpdateArgs = {
  input: RegistrationRequestJapanIndividualUpdateInput;
};


export type MutationRegistrationRequestJapanLegalEntityUpdateArgs = {
  input: RegistrationRequestJapanLegalEntityUpdateInput;
};


export type MutationRegistrationRequestVendorUpdateArgs = {
  input: RegistrationRequestVendorUpdateInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationSignInArgs = {
  input: SignInInput;
};


export type MutationUserChangePasswordArgs = {
  input: UserChangePasswordInput;
};


export type MutationUserRemoveTelegramArgs = {
  input: UserInput;
};


export type MutationUserUpdateNotificationSettingArgs = {
  input: SingleEntityInput;
};


export type MutationUserUpdateProfileArgs = {
  input: UserUpdateProfileInput;
};


export type MutationUserUpdateUserpicArgs = {
  input: UserUpdateUserpicInput;
};

/** Запчасть снятая */
export type Part = {
  __typename?: 'Part';
  /** Модель катализатора */
  catalyst?: Maybe<Catalyst>;
  /** Код хранения */
  code: Scalars['String']['output'];
  /** Вывод даты разными способами */
  cofirmedAt?: Maybe<Scalars['String']['output']>;
  /** Кто подтвердил списание */
  confirmer?: Maybe<User>;
  /** За кем резерв */
  counterparty?: Maybe<Counterparty>;
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  /** Кто отметил списание */
  deleter?: Maybe<User>;
  /** Модель ДВС */
  engineEquipment?: Maybe<EngineEquipment>;
  entityType: Scalars['String']['output'];
  /** Файлы */
  files?: Maybe<Array<Maybe<Media>>>;
  /** Модель КПП */
  gearboxModel?: Maybe<GearboxModel>;
  id: Scalars['ID']['output'];
  /** Комплектация авто */
  modelEquipment?: Maybe<ModelEquipment>;
  /** Название */
  name: Scalars['String']['output'];
  /** Тип запчасти */
  partType?: Maybe<TypeOfGenerationPart>;
  /** Цена в йенах */
  price: Scalars['Float']['output'];
  /** Вывод даты разными способами */
  reserveTillAt?: Maybe<Scalars['String']['output']>;
  /** Текущий сток */
  stock?: Maybe<Stock>;
};


/** Запчасть снятая */
export type PartCofirmedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Запчасть снятая */
export type PartDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Запчасть снятая */
export type PartReserveTillAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Составляющая запчасти */
export type PartComponent = {
  __typename?: 'PartComponent';
  /** Запчасть компонент */
  component?: Maybe<TypeOfGenerationPart>;
  /** Количество */
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

/** Порт */
export type Port = {
  __typename?: 'Port';
  /** Типы груза порта */
  cargos?: Maybe<Array<Maybe<PortCargo>>>;
  /** Страна порта */
  country?: Maybe<Country>;
  id: Scalars['ID']['output'];
  /** Название порта */
  name: Scalars['String']['output'];
  /** Ярд порта */
  yard?: Maybe<Yard>;
};

/** Тип груза порта с которым он работает */
export type PortCargo = {
  __typename?: 'PortCargo';
  /** Тип груза */
  cargo?: Maybe<TypeOfPort>;
  id: Scalars['ID']['output'];
  /** Порт */
  port?: Maybe<Port>;
};

/** Предварительный файл загрузки */
export type PreSignedFile = {
  __typename?: 'PreSignedFile';
  /** Вывод даты разными способами */
  created?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Файл */
  path?: Maybe<Scalars['String']['output']>;
  /** Размер */
  size?: Maybe<Scalars['String']['output']>;
  /** Создатель */
  user?: Maybe<User>;
};


/** Предварительный файл загрузки */
export type PreSignedFileCreatedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Префектура */
export type Prefecture = {
  __typename?: 'Prefecture';
  /** Цена доставки в префектуре */
  baseDeliveryPrice: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Название EN */
  nameEn: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Список операций подотчета с наличными у сотрудника */
  CashHistory: CashAccountableOperationPagination;
  /** Список стран */
  Countries?: Maybe<CountryPagination>;
  /** Список языков */
  Languages: Array<Maybe<Language>>;
  /** Данные по авто из лоту отбора */
  LotSelectionCarCheckQuery: Scalars['String']['output'];
  /** Список операций подотчета с типом наклейки у сотрудника */
  TaxStickerHistory: TaxStickerAccountableOperationPagination;
  /** Список налоговых наклеек */
  TaxStickers: TaxStickerPagination;
  /** Получить текущего пользователя */
  currentUser?: Maybe<User>;
};


export type QueryCashHistoryArgs = {
  filter?: InputMaybe<CashHistoryFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCountriesArgs = {
  filter?: InputMaybe<CountriesFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLotSelectionCarCheckQueryArgs = {
  manufacturer: Scalars['String']['input'];
  model: Scalars['String']['input'];
  rightVinPart: Scalars['String']['input'];
};


export type QueryTaxStickerHistoryArgs = {
  filter?: InputMaybe<TaxStickerHistoryFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTaxStickersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Лицензия ресайкла */
export type RecycleLicense = {
  __typename?: 'RecycleLicense';
  /** Контрагент */
  counterparty?: Maybe<Counterparty>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Признак активности */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Логин в системе ресайкла */
  login?: Maybe<Scalars['String']['output']>;
  /** Номер лицензии */
  number: Scalars['String']['output'];
  /** password в системе ресайкла */
  password?: Maybe<Scalars['String']['output']>;
  /** Этап */
  recycleStage?: Maybe<RecycleStage>;
  /** Цех */
  workshop?: Maybe<Workshop>;
};

/** Этап ресайкла */
export type RecycleStage = {
  __typename?: 'RecycleStage';
  id: Scalars['ID']['output'];
  /** Название этапа */
  name: Scalars['String']['output'];
};

/** Refresh token */
export type RefreshToken = {
  __typename?: 'RefreshToken';
  token?: Maybe<Scalars['String']['output']>;
};

export type RefreshTokenInput = {
  /** Токен */
  refreshToken: Scalars['String']['input'];
};

/** Заявка на регистрацию контрагента */
export type RegistrationRequest = {
  __typename?: 'RegistrationRequest';
  /** Вывод даты разными способами */
  acceptedAt?: Maybe<Scalars['String']['output']>;
  /** Класс контрагента */
  class?: Maybe<CounterpartyClass>;
  /** Comment for request */
  comment?: Maybe<Scalars['String']['output']>;
  /** Company Name */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Company registered address */
  companyRegisteredAddress?: Maybe<Scalars['String']['output']>;
  /** Date of registration company */
  companyRegistrationDate?: Maybe<Scalars['String']['output']>;
  /** Company Registration Number */
  companyRegistrationNumber?: Maybe<Scalars['String']['output']>;
  /** Contact person in company */
  contactPerson?: Maybe<Scalars['String']['output']>;
  /** Список контрагентов с таким емейлом */
  counterparties?: Maybe<Array<Maybe<Counterparty>>>;
  /** Созданный контрагент */
  counterparty?: Maybe<Counterparty>;
  /** Страна контрагента */
  country?: Maybe<Country>;
  /** Вывод даты разными способами */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  declinedAt?: Maybe<Scalars['String']['output']>;
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  /** Fax */
  fax?: Maybe<Scalars['String']['output']>;
  /** Full name of person */
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Invoice number */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** Покупка целых авто */
  isCars?: Maybe<Scalars['Boolean']['output']>;
  /** Покупка ДВС */
  isEngine?: Maybe<Scalars['Boolean']['output']>;
  /** Покупка запчастей */
  isParts?: Maybe<Scalars['Boolean']['output']>;
  /** Язык контрагента */
  language?: Maybe<Language>;
  /** Менеджер, обработавший заявку */
  manager?: Maybe<User>;
  /** Комментарий  менеджера */
  managerComment?: Maybe<Scalars['String']['output']>;
  /** Phone */
  phone?: Maybe<Scalars['String']['output']>;
  /** Postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  processedAt?: Maybe<Scalars['String']['output']>;
  /** Tax Indentification Number */
  tin?: Maybe<Scalars['String']['output']>;
  /** Список юзеров с таким емейлом */
  users?: Maybe<Array<Maybe<User>>>;
  /** WahtsApp number */
  whatsapp?: Maybe<Scalars['String']['output']>;
};


/** Заявка на регистрацию контрагента */
export type RegistrationRequestAcceptedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Заявка на регистрацию контрагента */
export type RegistrationRequestCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Заявка на регистрацию контрагента */
export type RegistrationRequestDeclinedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Заявка на регистрацию контрагента */
export type RegistrationRequestProcessedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegistrationRequestForeignIndividualUpdateInput = {
  /** Комментарий */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Контактное лицо */
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  /** Страна */
  country: Scalars['ID']['input'];
  /** Email контрагента */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Имя */
  fullName: Scalars['String']['input'];
  /** Покупка целых авто */
  isCars?: InputMaybe<Scalars['Boolean']['input']>;
  /** Покупка ДВС */
  isEngine?: InputMaybe<Scalars['Boolean']['input']>;
  /** Покупка запчастей */
  isParts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Язык по умолчанию */
  language: Scalars['ID']['input'];
  /** Контактный телефон */
  phone: Scalars['String']['input'];
  /** Адрес регистрации контрагента */
  registeredAddress?: InputMaybe<Scalars['String']['input']>;
  /** Номер WhatsApp */
  whatsapp?: InputMaybe<Scalars['String']['input']>;
};

export type RegistrationRequestForeignLegalEntityUpdateInput = {
  /** Комментарий */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Адрес юридического лица контрагента */
  companyAddress: Scalars['String']['input'];
  /** Название контрагента */
  companyName: Scalars['String']['input'];
  /** Контактное лицо */
  contactPerson: Scalars['String']['input'];
  /** Страна */
  country: Scalars['ID']['input'];
  /** Email контрагента */
  email: Scalars['String']['input'];
  /** Покупка целых авто */
  isCars?: InputMaybe<Scalars['Boolean']['input']>;
  /** Покупка ДВС */
  isEngine?: InputMaybe<Scalars['Boolean']['input']>;
  /** Покупка запчастей */
  isParts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Язык по умолчанию */
  language: Scalars['ID']['input'];
  /** Контактный телефон */
  phone: Scalars['String']['input'];
  /** Номер WhatsApp */
  whatsapp?: InputMaybe<Scalars['String']['input']>;
};

export type RegistrationRequestJapanIndividualUpdateInput = {
  /** Комментарий */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Адрес физического лица контрагента */
  companyAddress: Scalars['String']['input'];
  /** Контактное лицо */
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  /** Страна */
  country: Scalars['ID']['input'];
  /** Email контрагента */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Факс */
  fax?: InputMaybe<Scalars['String']['input']>;
  /** Полное имя контрагента */
  fullName: Scalars['String']['input'];
  /** Язык по умолчанию */
  language: Scalars['ID']['input'];
  /** Контактный телефон */
  phone: Scalars['String']['input'];
  /** Почтовый индекс */
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type RegistrationRequestJapanLegalEntityUpdateInput = {
  /** Комментарий */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Название контрагента */
  companyName: Scalars['String']['input'];
  /** Контактное лицо */
  contactPerson: Scalars['String']['input'];
  /** Страна */
  country: Scalars['ID']['input'];
  /** Email контрагента */
  email: Scalars['String']['input'];
  /** Факс */
  fax?: InputMaybe<Scalars['String']['input']>;
  /** Номер счёта контрагента */
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  /** Язык по умолчанию */
  language: Scalars['ID']['input'];
  /** Контактный телефон */
  phone: Scalars['String']['input'];
  /** Почтовый индекс */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Дата регистрации контрагента */
  registrationDate?: InputMaybe<Scalars['String']['input']>;
  /** Регистрационный номер контрагента */
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RegistrationRequestVendorUpdateInput = {
  /** Комментарий */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Адрес контрагента */
  companyAddress: Scalars['String']['input'];
  /** Название контрагента */
  companyName: Scalars['String']['input'];
  /** Контактное лицо */
  contactPerson: Scalars['String']['input'];
  /** Страна */
  country: Scalars['ID']['input'];
  /** Email контрагента */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Факс */
  fax?: InputMaybe<Scalars['String']['input']>;
  /** Номер счёта контрагента */
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  /** Язык по умолчанию */
  language: Scalars['ID']['input'];
  /** Контактный телефон */
  phone: Scalars['String']['input'];
  /** Почтовый индекс */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Дата регистрации контрагента */
  registrationDate?: InputMaybe<Scalars['String']['input']>;
  /** Регистрационный номер контрагента */
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ResetPasswordInput = {
  /** Логин учетной записи */
  login: Scalars['String']['input'];
  /** Новый пароль */
  password: Scalars['String']['input'];
  /** Подтверждение пароля */
  passwordConfirm: Scalars['String']['input'];
  /** Токен сброса пароля */
  token: Scalars['String']['input'];
};

/** Enum списка ролей */
export enum RoleEnum {
  Accrual = 'ACCRUAL',
  Auc = 'AUC',
  Brigadier = 'BRIGADIER',
  Check = 'CHECK',
  Driver = 'DRIVER',
  Ecar = 'ECAR',
  JpCars = 'JP_CARS',
  JpSales = 'JP_SALES',
  Know = 'KNOW',
  Logistic = 'LOGISTIC',
  Manager = 'MANAGER',
  My = 'MY',
  Report = 'REPORT',
  Stock = 'STOCK',
  UaeManager = 'UAE_MANAGER',
  UsSales = 'US_SALES'
}

/** Продажа */
export type Sale = {
  __typename?: 'Sale';
  /** Плательщик */
  counterparty?: Maybe<Counterparty>;
  /** Вывод даты разными способами */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Валюта продажи */
  currency?: Maybe<Currency>;
  /** Список начислений долга */
  debtAccruals?: Maybe<Array<Maybe<DebtAccrual>>>;
  id: Scalars['ID']['output'];
  /** Форма денег */
  moneyType?: Maybe<TypeOfMoney>;
  /** Продавец */
  seller?: Maybe<Counterparty>;
  /** Список накладных на выдачу со склада */
  stockInvoices?: Maybe<Array<Maybe<StockInvoice>>>;
  /** Баланс после */
  totalAmount?: Maybe<Scalars['Float']['output']>;
  /** Грузовики */
  truck?: Maybe<Truck>;
  /** Вывод даты разными способами */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Кто провел */
  user?: Maybe<User>;
  /** Список кузовов остовов авто */
  vehicleBodies?: Maybe<Array<Maybe<VehicleBody>>>;
};


/** Продажа */
export type SaleCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Продажа */
export type SaleUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Услуга для начислений */
export type Service = {
  __typename?: 'Service';
  id: Scalars['ID']['output'];
  /** Название */
  name?: Maybe<Scalars['String']['output']>;
};

/** Регламент обслуживания */
export type ServiceRegulation = {
  __typename?: 'ServiceRegulation';
  /** Действия */
  actions: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Единица измерения */
  unitOfMeasure?: Maybe<UnitOfMeasure>;
};

/** Техника ААН */
export type ServiceVehicle = {
  __typename?: 'ServiceVehicle';
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** История обслуживания */
  maintenances?: Maybe<Array<Maybe<ServiceVehicleMaintenance>>>;
  /** Название */
  name: Scalars['String']['output'];
  /** Регламенты */
  regulations?: Maybe<Array<Maybe<ServiceVehicleRegulation>>>;
};

/** История обслуживания техники */
export type ServiceVehicleMaintenance = {
  __typename?: 'ServiceVehicleMaintenance';
  /** Вывод даты разными способами */
  createdAt?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Ппропустили лимит обслуживания */
  isLate: Scalars['Boolean']['output'];
  /** Регламент */
  regulation?: Maybe<ServiceRegulation>;
  /** Текущая наработка */
  uptimeCurrent: Scalars['Float']['output'];
  /** Лимит обслуживания */
  uptimeLimit: Scalars['Float']['output'];
  /** Общая наработка */
  uptimeTotal: Scalars['Float']['output'];
};


/** История обслуживания техники */
export type ServiceVehicleMaintenanceCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Регламент обслуживания техники ААН */
export type ServiceVehicleRegulation = {
  __typename?: 'ServiceVehicleRegulation';
  /** Предупреждать за */
  alertBefore: Scalars['Float']['output'];
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Признак удаления */
  isDeleted: Scalars['Boolean']['output'];
  /** Регламент */
  regulation?: Maybe<ServiceRegulation>;
  /** Текущая наработка */
  uptimeCurrent: Scalars['Float']['output'];
  /** Лимит обслуживания */
  uptimeLimit: Scalars['Float']['output'];
  /** Общая наработка */
  uptimeTotal: Scalars['Float']['output'];
};

export type SignInInput = {
  /** Логин учетной записи */
  login: Scalars['String']['input'];
  /** Пароль */
  password: Scalars['String']['input'];
};

export type SingleEntityInput = {
  /** ID сущности */
  id: Scalars['ID']['input'];
};

/** Статус */
export type Status = {
  __typename?: 'Status';
  id: Scalars['ID']['output'];
  /** Название */
  name?: Maybe<Scalars['String']['output']>;
};

/** Сток */
export type Stock = {
  __typename?: 'Stock';
  /** Адрес */
  address?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Список связок ползователь - сток */
  userToStocks?: Maybe<Array<Maybe<UserToStock>>>;
};

/** Инвентаризация стока */
export type StockInventory = {
  __typename?: 'StockInventory';
  /** Вывод даты разными способами */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Кто запустил */
  creator?: Maybe<User>;
  /** Вывод даты разными способами */
  finishedAt?: Maybe<Scalars['String']['output']>;
  /** Кто завершил */
  finisher?: Maybe<User>;
  id: Scalars['ID']['output'];
  /** Сток */
  stock?: Maybe<Stock>;
};


/** Инвентаризация стока */
export type StockInventoryCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Инвентаризация стока */
export type StockInventoryFinishedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Объект инвентаризации стока */
export type StockInventoryObject = {
  __typename?: 'StockInventoryObject';
  id: Scalars['ID']['output'];
  /** Изначально не было в списке */
  isNew: Scalars['Boolean']['output'];
  /** Вывод даты разными способами */
  markedAt?: Maybe<Scalars['String']['output']>;
  /** Запчасть */
  part?: Maybe<Part>;
  /** Водитель */
  user?: Maybe<User>;
};


/** Объект инвентаризации стока */
export type StockInventoryObjectMarkedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Накладная на перемещение запчастей по стокам */
export type StockInvoice = {
  __typename?: 'StockInvoice';
  /** Код накладной */
  code: Scalars['String']['output'];
  /** Покупатель */
  counterparty?: Maybe<Counterparty>;
  /** Вывод даты разными способами */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Кто создал */
  creator?: Maybe<User>;
  /** Водитель */
  driver?: Maybe<User>;
  entityType: Scalars['String']['output'];
  /** Кто закрыл */
  finisher?: Maybe<User>;
  id: Scalars['ID']['output'];
  /** Признак удаления */
  isDelete: Scalars['Boolean']['output'];
  /** Признак что накладная закрыта по выдаче */
  isFinishIssue: Scalars['Boolean']['output'];
  /** Признак что накладная закрыта по получению */
  isFinishRecieve: Scalars['Boolean']['output'];
  /** Продажа */
  sale?: Maybe<Sale>;
  /** Сток откуда */
  stockFrom?: Maybe<Stock>;
  /** Сток назначения */
  stockTo?: Maybe<Stock>;
};


/** Накладная на перемещение запчастей по стокам */
export type StockInvoiceCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Объект накладной перемещения запчастей по стокам */
export type StockInvoiceObject = {
  __typename?: 'StockInvoiceObject';
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Флаг удаления из накладной */
  isDelete: Scalars['Boolean']['output'];
  /** Вывод даты разными способами */
  issuedAt?: Maybe<Scalars['String']['output']>;
  /** Кто выдал со стока */
  issuer?: Maybe<User>;
  /** Запчасть */
  part?: Maybe<Part>;
  /** Вывод даты разными способами */
  recievedAt?: Maybe<Scalars['String']['output']>;
  /** Кто принял на сток */
  reciever?: Maybe<User>;
};


/** Объект накладной перемещения запчастей по стокам */
export type StockInvoiceObjectIssuedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Объект накладной перемещения запчастей по стокам */
export type StockInvoiceObjectRecievedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Синоним */
export type Synonym = {
  __typename?: 'Synonym';
  id: Scalars['ID']['output'];
  /** Синоним */
  name: Scalars['String']['output'];
};

/** Налоговая наклейка на чек */
export type TaxSticker = {
  __typename?: 'TaxSticker';
  /** Количество в офисе */
  boxCount?: Maybe<Scalars['Float']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Название */
  name?: Maybe<Scalars['String']['output']>;
  /** Номинал */
  value?: Maybe<Scalars['Float']['output']>;
};

/** Подотчетная операция с налоговыми наклейками */
export type TaxStickerAccountableOperation = {
  __typename?: 'TaxStickerAccountableOperation';
  /** Количество после */
  countAfter?: Maybe<Scalars['Int']['output']>;
  /** Количество до */
  countBefore?: Maybe<Scalars['Int']['output']>;
  /** Количество */
  countChange?: Maybe<Scalars['Int']['output']>;
  /** Вывод даты разными способами */
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Тип операции */
  operationType?: Maybe<TypeOfAccountableOperation>;
  /** Вывод даты разными способами */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Кто провел операцию */
  user?: Maybe<User>;
  /** Подотчетный тип стикера */
  userTaxSticker?: Maybe<UserTaxSticker>;
};


/** Подотчетная операция с налоговыми наклейками */
export type TaxStickerAccountableOperationCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Подотчетная операция с налоговыми наклейками */
export type TaxStickerAccountableOperationUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaxStickerAccountableOperationPagination = {
  __typename?: 'TaxStickerAccountableOperationPagination';
  /** Current page of the cursor */
  current_page: Scalars['Int']['output'];
  /** List of items on the current page */
  data: Array<TaxStickerAccountableOperation>;
  /** Number of the first item returned */
  from?: Maybe<Scalars['Int']['output']>;
  /** Determines if cursor has more pages after the current page */
  has_more_pages: Scalars['Boolean']['output'];
  /** The last page (number of pages) */
  last_page: Scalars['Int']['output'];
  /** Number of items returned per page */
  per_page: Scalars['Int']['output'];
  /** Number of the last item returned */
  to?: Maybe<Scalars['Int']['output']>;
  /** Number of total items selected by the query */
  total: Scalars['Int']['output'];
};

export type TaxStickerHistoryFilterInput = {
  /** ID подотченой наклейки сотрудника */
  userTaxSticker?: InputMaybe<Scalars['ID']['input']>;
};

export type TaxStickerPagination = {
  __typename?: 'TaxStickerPagination';
  /** Current page of the cursor */
  current_page: Scalars['Int']['output'];
  /** List of items on the current page */
  data: Array<TaxSticker>;
  /** Number of the first item returned */
  from?: Maybe<Scalars['Int']['output']>;
  /** Determines if cursor has more pages after the current page */
  has_more_pages: Scalars['Boolean']['output'];
  /** The last page (number of pages) */
  last_page: Scalars['Int']['output'];
  /** Number of items returned per page */
  per_page: Scalars['Int']['output'];
  /** Number of the last item returned */
  to?: Maybe<Scalars['Int']['output']>;
  /** Number of total items selected by the query */
  total: Scalars['Int']['output'];
};

/** Тир машины */
export type Tier = {
  __typename?: 'Tier';
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Трансмиссия */
export type Transmission = {
  __typename?: 'Transmission';
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Порт контрагента */
export type Truck = {
  __typename?: 'Truck';
  id: Scalars['ID']['output'];
  /** Марка модель */
  name: Scalars['String']['output'];
  /** Номерной знак */
  plate: Scalars['String']['output'];
  /** Грузоподъемность */
  tonnage: Scalars['Float']['output'];
};

/** Тип подотчетный операции */
export type TypeOfAccountableOperation = {
  __typename?: 'TypeOfAccountableOperation';
  id: Scalars['ID']['output'];
  /** Название */
  name?: Maybe<Scalars['String']['output']>;
};

/** Тип транзакции */
export type TypeOfBalanceTransaction = {
  __typename?: 'TypeOfBalanceTransaction';
  id: Scalars['ID']['output'];
  /** Название */
  name?: Maybe<Scalars['String']['output']>;
};

/** Тип ставки */
export type TypeOfBid = {
  __typename?: 'TypeOfBid';
  /** Типы навальных продуктов */
  bidTypeBulks: Array<BidTypeBulk>;
  /** Типы запчастей */
  bidTypeGenerationParts: Array<BidTypeGenerationPart>;
  id: Scalars['ID']['output'];
  /** Учитывать все навальные продукты при продаже */
  isAllBulks: Scalars['Boolean']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Тип */
  type: Scalars['String']['output'];
};

/** Тип чата */
export type TypeOfChat = {
  __typename?: 'TypeOfChat';
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Тип контейнера */
export type TypeOfContainer = {
  __typename?: 'TypeOfContainer';
  /** Вес пустого контейнера */
  deadWeight?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** Признак чтов контейнер можно грузить запчасти */
  isPartAvailable: Scalars['Boolean']['output'];
  /** Предельный вес контейнера */
  maxWeight?: Maybe<Scalars['Float']['output']>;
  /** Название */
  name?: Maybe<Scalars['String']['output']>;
};

/** Тип доставки */
export type TypeOfDelivery = {
  __typename?: 'TypeOfDelivery';
  id: Scalars['ID']['output'];
  /** Название */
  name?: Maybe<Scalars['String']['output']>;
};

/** Тип комплектации ДВС */
export type TypeOfEngineEquipment = {
  __typename?: 'TypeOfEngineEquipment';
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  /** Тип запчасти */
  generationPartType?: Maybe<TypeOfGenerationPart>;
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};


/** Тип комплектации ДВС */
export type TypeOfEngineEquipmentDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Тип экспорта */
export type TypeOfExport = {
  __typename?: 'TypeOfExport';
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Тип файла */
export type TypeOfFile = {
  __typename?: 'TypeOfFile';
  id: Scalars['ID']['output'];
  /** Название */
  name?: Maybe<Scalars['String']['output']>;
};

/** Тип оплаты фрахта */
export type TypeOfFreight = {
  __typename?: 'TypeOfFreight';
  /** Код */
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Тип КПП */
export type TypeOfGearbox = {
  __typename?: 'TypeOfGearbox';
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Тип запчасти */
export type TypeOfGenerationPart = {
  __typename?: 'TypeOfGenerationPart';
  /** Базовый тип запчасти */
  baseType?: Maybe<TypeOfGenerationPart>;
  /** Список составляющих */
  components?: Maybe<Array<Maybe<PartComponent>>>;
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  /** Поколение */
  generation?: Maybe<Generation>;
  /** Модель */
  generationModel?: Maybe<GenerationModel>;
  id: Scalars['ID']['output'];
  /** Данный тип запчасти невозможен */
  isNotExist: Scalars['Boolean']['output'];
  /** Признак покупки для продажи в Штаты */
  isUSPriority: Scalars['Boolean']['output'];
  /** Комплектация */
  modelEquipment?: Maybe<ModelEquipment>;
  /** Название */
  name: Scalars['String']['output'];
  /** Тип упаковки */
  package?: Maybe<TypeOfPackage>;
  /** Расход индивидуальной упаковки */
  packageCost: Scalars['Float']['output'];
  /** Цена запчасти */
  partPrice: Scalars['Float']['output'];
  /** Тип формулы цены */
  partPriceType?: Maybe<TypeOfPartPrice>;
  /** Тир */
  tier?: Maybe<Tier>;
};


/** Тип запчасти */
export type TypeOfGenerationPartDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Трансмиссия лота */
export type TypeOfLotTrasmission = {
  __typename?: 'TypeOfLotTrasmission';
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Форма денег */
export type TypeOfMoney = {
  __typename?: 'TypeOfMoney';
  id: Scalars['ID']['output'];
  /** Название */
  name?: Maybe<Scalars['String']['output']>;
};

/** Тип упаковки */
export type TypeOfPackage = {
  __typename?: 'TypeOfPackage';
  /** Вывод даты разными способами */
  deletedAt?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Остаток */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** Стоимость за единицу */
  unitCost?: Maybe<Scalars['Float']['output']>;
  /** единица измерения */
  unitOfMeasure?: Maybe<UnitOfMeasure>;
};


/** Тип упаковки */
export type TypeOfPackageDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Тип цены запчасти */
export type TypeOfPartPrice = {
  __typename?: 'TypeOfPartPrice';
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Тип порта */
export type TypeOfPort = {
  __typename?: 'TypeOfPort';
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Единица измерения */
export type UnitOfMeasure = {
  __typename?: 'UnitOfMeasure';
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Сокращение */
  unit: Scalars['String']['output'];
};

/** Пользователь */
export type User = {
  __typename?: 'User';
  /** Список связок ползователь - аукцион */
  UserToAuctions?: Maybe<Array<Maybe<UserToAuction>>>;
  /** Список связок ползователь - сток */
  UserToStocks?: Maybe<Array<Maybe<UserToStock>>>;
  /** Список связок ползователь - цех */
  UserToWorkshops?: Maybe<Array<Maybe<UserToWorkshop>>>;
  /** Список связок ползователь - ярд */
  UserToYards?: Maybe<Array<Maybe<UserToYard>>>;
  /** Флаг активности или блокировки */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Список подотчет наличных */
  balances?: Maybe<Array<Maybe<CashBalance>>>;
  /** Контрагент */
  counterparty?: Maybe<Counterparty>;
  /** Язык по умолчанию */
  currentLanguage?: Maybe<Language>;
  /** Текущий сток */
  currentStock?: Maybe<Stock>;
  /** Текущий цех */
  currentWorkshop?: Maybe<Workshop>;
  /** Текущий ярд */
  currentYard?: Maybe<Yard>;
  /** User email */
  email?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  /** История событий */
  history?: Maybe<Array<Maybe<LogEvent>>>;
  id: Scalars['ID']['output'];
  /** User name */
  name: Scalars['String']['output'];
  /** Настройки уведомлений */
  notificationSettings?: Maybe<Array<Maybe<UserNotificationSetting>>>;
  /** Список доступных рабочих мест */
  roles?: Maybe<Array<Maybe<Workspace>>>;
  /** Список подотчет наклеек */
  taxStickers?: Maybe<Array<Maybe<UserTaxSticker>>>;
  /** id канала ТГ */
  telegram?: Maybe<Scalars['String']['output']>;
  /** Ссылка на ТГ бота */
  telegramUrl?: Maybe<Scalars['String']['output']>;
  /** Auth token */
  token?: Maybe<Scalars['String']['output']>;
  /** User profile photo media */
  userpic?: Maybe<Media>;
  /** Рабочее место по умолчанию */
  workspace?: Maybe<Workspace>;
};

export type UserChangePasswordInput = {
  /** Новый пароль */
  password: Scalars['String']['input'];
  /** Подтверждение пароля */
  passwordConfirm: Scalars['String']['input'];
  /** Старый пароль */
  passwordOld: Scalars['String']['input'];
};

export type UserInput = {
  /** ID пользователя */
  user: Scalars['ID']['input'];
};

/** Настройка получения сообщений */
export type UserNotificationSetting = {
  __typename?: 'UserNotificationSetting';
  id: Scalars['ID']['output'];
  /** Метка получать или нет */
  isEnabled: Scalars['Boolean']['output'];
  /** Значение изменять нельзя */
  isLock: Scalars['Boolean']['output'];
  /** Название уведомления */
  name?: Maybe<Scalars['String']['output']>;
};

/** Налоговая наклейка на чек в подотчете у сотрудника */
export type UserTaxSticker = {
  __typename?: 'UserTaxSticker';
  /** Количество */
  count?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Наклейка */
  taxSticker?: Maybe<TaxSticker>;
  /** Сотрудник */
  user?: Maybe<User>;
};

/** Привязка аукциониста к аукциону */
export type UserToAuction = {
  __typename?: 'UserToAuction';
  /** Аукцион */
  auction?: Maybe<Auction>;
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Пользователь */
  user?: Maybe<User>;
};

/** Привязка сотрудника к стоку */
export type UserToStock = {
  __typename?: 'UserToStock';
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Сток */
  stock?: Maybe<Stock>;
  /** Пользователь */
  user?: Maybe<User>;
};

/** Привязка сотрудника к цеху */
export type UserToWorkshop = {
  __typename?: 'UserToWorkshop';
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Пользователь */
  user?: Maybe<User>;
  /** Цех */
  workshop?: Maybe<Workshop>;
};

/** Привязка сотрудника к ярду */
export type UserToYard = {
  __typename?: 'UserToYard';
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Пользователь */
  user?: Maybe<User>;
  /** Ярд */
  yard?: Maybe<Yard>;
};

export type UserUpdateProfileInput = {
  /** Почта пользователя */
  email: Scalars['String']['input'];
  /** Язык пользователя по умолчанию */
  language: Scalars['ID']['input'];
};

export type UserUpdateUserpicInput = {
  /** ID presigned файла */
  file: Scalars['ID']['input'];
  /** ID пользователя */
  user: Scalars['ID']['input'];
};

/** Машина */
export type Vehicle = {
  __typename?: 'Vehicle';
  /** BL */
  BL?: Maybe<Array<Maybe<Media>>>;
  /** Букинг контейнера */
  CB?: Maybe<Array<Maybe<Media>>>;
  /** Коносамент */
  CS?: Maybe<Array<Maybe<Media>>>;
  /** Букинг рейса парохода */
  EB?: Maybe<Array<Maybe<Media>>>;
  /** Эскпортный сертификат */
  EC?: Maybe<Array<Maybe<Media>>>;
  /** Экспортная декларация */
  ED?: Maybe<Array<Maybe<Media>>>;
  /** Экспортная инспекция */
  EI?: Maybe<Array<Maybe<Media>>>;
  /** Экспортный инвойс */
  INV?: Maybe<Array<Maybe<Media>>>;
  /** ISF */
  ISF?: Maybe<Array<Maybe<Media>>>;
  /** Упаковочный лист */
  PL?: Maybe<Array<Maybe<Media>>>;
  /** BL с отметкой для выдачи */
  SBL?: Maybe<Array<Maybe<Media>>>;
  /** SI */
  SI?: Maybe<Array<Maybe<Media>>>;
  /** Международный перевозчик */
  WWcarrier?: Maybe<Counterparty>;
  /** ПТС на ААН */
  aanDocs?: Maybe<Array<Maybe<Media>>>;
  /** Вывод даты разными способами */
  arrivedToTardAt?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  aucDeadlineAt?: Maybe<Scalars['String']['output']>;
  /** Документы с аукциона */
  aucDocs?: Maybe<Array<Maybe<Media>>>;
  /** Вывод даты разными способами */
  aucDocsOfficeAt?: Maybe<Scalars['String']['output']>;
  /** Тип покупки */
  bidType?: Maybe<TypeOfBid>;
  /** Брокер */
  broker?: Maybe<Counterparty>;
  /** Покупатель */
  buyer?: Maybe<Counterparty>;
  /** Список катализаторов */
  catalysts?: Maybe<Array<Maybe<VehicleCatalyst>>>;
  /** Код хранения */
  code: Scalars['String']['output'];
  /** Вывод даты разными способами */
  completedAt?: Maybe<Scalars['String']['output']>;
  /** Грузополучатель */
  consignee?: Maybe<Consignee>;
  /** Контейнер */
  container?: Maybe<Container>;
  /** Текущий этап ресайкла */
  currentRecycleStage?: Maybe<VehicleRecycleStage>;
  /** Вывод даты разными способами */
  disassemblyPermissionAt?: Maybe<Scalars['String']['output']>;
  /** Перевозчик документов */
  docCarrier?: Maybe<Counterparty>;
  /** Трекинг документов */
  docTrackingNumber?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  ecReceivedAt?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  ecValidUntil?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  /** Экспортный рейс */
  exportTrip?: Maybe<ExportTrip>;
  /** Тип экспорта */
  exportType?: Maybe<TypeOfExport>;
  /** Файлы */
  files?: Maybe<Array<Maybe<Media>>>;
  /** Тип оплаты фрахта */
  freightPaymentType?: Maybe<TypeOfFreight>;
  /** Вывод даты разными способами */
  gasRecievedAt?: Maybe<Scalars['String']['output']>;
  /** Емкость газа при разборе */
  gasTank?: Maybe<GasTank>;
  id: Scalars['ID']['output'];
  /** Катализатор в наличии на авто */
  isCatalyst: Scalars['Boolean']['output'];
  /** Катализатор дорогой, проверить на ярде */
  isExpensiveCatalyst: Scalars['Boolean']['output'];
  /** Доставка номера сторонне организацией */
  isPlateDelivery: Scalars['Boolean']['output'];
  /** Лот */
  lot?: Maybe<Lot>;
  /** Лот отбора */
  lotSelection?: Maybe<LotSelection>;
  /** Список запчастей снятых */
  parts?: Maybe<Array<Maybe<Part>>>;
  plate?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  plateOfficeAt?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  plateRikunAt?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  plateTillAt?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  purchasedAt?: Maybe<Scalars['String']['output']>;
  /** Список этапов ресайкла */
  recycleStages?: Maybe<Array<Maybe<VehicleRecycleStage>>>;
  /** Вывод даты разными способами */
  rikunOwnerChangedAt?: Maybe<Scalars['String']['output']>;
  /** Статус */
  status?: Maybe<Status>;
  /** Список запчастей для разбора */
  vehicleParts?: Maybe<Array<Maybe<VehiclePart>>>;
  /** Параметры из системы ресайкла */
  vehicleRecycleParam?: Maybe<VehicleRecycleParam>;
  /** Номер кузова */
  vin: Scalars['String']['output'];
  /** Номер кузова дополнительный */
  vin2?: Maybe<Scalars['String']['output']>;
  /** Цех разбора */
  workshop?: Maybe<Workshop>;
  /** Ярд */
  yard?: Maybe<Yard>;
  /** Сектор ярда */
  yardSector?: Maybe<YardSector>;
};


/** Машина */
export type VehicleArrivedToTardAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Машина */
export type VehicleAucDeadlineAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Машина */
export type VehicleAucDocsOfficeAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Машина */
export type VehicleCompletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Машина */
export type VehicleDisassemblyPermissionAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Машина */
export type VehicleEcReceivedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Машина */
export type VehicleEcValidUntilArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Машина */
export type VehicleGasRecievedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Машина */
export type VehiclePlateOfficeAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Машина */
export type VehiclePlateRikunAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Машина */
export type VehiclePlateTillAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Машина */
export type VehiclePurchasedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Машина */
export type VehicleRikunOwnerChangedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Кузов авто для пресса */
export type VehicleBody = {
  __typename?: 'VehicleBody';
  id: Scalars['ID']['output'];
  /** Название */
  isHiddenRecycle: Scalars['Boolean']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Вывод даты разными способами */
  reportInAt?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  reportOutAt?: Maybe<Scalars['String']['output']>;
  /** Продажа */
  sale?: Maybe<Sale>;
  /** Название */
  vin: Scalars['String']['output'];
};


/** Кузов авто для пресса */
export type VehicleBodyReportInAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Кузов авто для пресса */
export type VehicleBodyReportOutAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Катализатор авто */
export type VehicleCatalyst = {
  __typename?: 'VehicleCatalyst';
  /** Модель катализатора */
  catalyst?: Maybe<Catalyst>;
  id: Scalars['ID']['output'];
  /** Количество */
  quantity: Scalars['Int']['output'];
};

export type VehicleCommonDashboard = {
  __typename?: 'VehicleCommonDashboard';
  /** Машин на странице */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Страниц */
  pages?: Maybe<Scalars['Int']['output']>;
  /** Машины */
  vehicles?: Maybe<Array<Maybe<VehicleDashboard>>>;
};

export type VehicleDashboard = {
  __typename?: 'VehicleDashboard';
  /** Аукционный взнос */
  aucCost?: Maybe<Scalars['Float']['output']>;
  /** Стоимость на кнопке */
  bidCost?: Maybe<Scalars['Float']['output']>;
  /** Расходы на доставку */
  deliveryCost?: Maybe<Scalars['Float']['output']>;
  /** Налог на утилизацию */
  recycleCost?: Maybe<Scalars['Float']['output']>;
  /** Общие расходы */
  totalCost?: Maybe<Scalars['Float']['output']>;
  /** Машина */
  vehicle: Vehicle;
};

/** Запчасть для снятия */
export type VehiclePart = {
  __typename?: 'VehiclePart';
  /** Комментарий */
  comment?: Maybe<Scalars['String']['output']>;
  /** За кем резерв */
  counterparty?: Maybe<Counterparty>;
  entityType: Scalars['String']['output'];
  /** Причина по которой не снято */
  failReason?: Maybe<Scalars['String']['output']>;
  /** Файлы */
  files?: Maybe<Array<Maybe<Media>>>;
  id: Scalars['ID']['output'];
  /** Катализатор в наличии на авто */
  isMarked: Scalars['Boolean']['output'];
  /** Снятая запчасть */
  part?: Maybe<Part>;
  /** Тип запчасти */
  partType?: Maybe<TypeOfGenerationPart>;
  /** Вывод даты разными способами */
  reserveTillAt?: Maybe<Scalars['String']['output']>;
};


/** Запчасть для снятия */
export type VehiclePartReserveTillAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Параметры авто из системы ресайкла */
export type VehicleRecycleParam = {
  __typename?: 'VehicleRecycleParam';
  id: Scalars['ID']['output'];
  /** sydinoTxt */
  sydinoTxt?: Maybe<Scalars['String']['output']>;
};

/** Этап ресайкла конкретного авто */
export type VehicleRecycleStage = {
  __typename?: 'VehicleRecycleStage';
  id: Scalars['ID']['output'];
  /** Этап */
  recycleStage?: Maybe<RecycleStage>;
  /** Отчет принятия на этап */
  reportIn?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  reportInAt?: Maybe<Scalars['String']['output']>;
  /** Отчет передачи дальше */
  reportOut?: Maybe<Scalars['String']['output']>;
  /** Вывод даты разными способами */
  reportOutAt?: Maybe<Scalars['String']['output']>;
};


/** Этап ресайкла конкретного авто */
export type VehicleRecycleStageReportInAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Этап ресайкла конкретного авто */
export type VehicleRecycleStageReportOutAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** СУдно */
export type Vessel = {
  __typename?: 'Vessel';
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
};

/** Цех */
export type Workshop = {
  __typename?: 'Workshop';
  /** Адрес */
  address?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Лицензии ресайкла */
  recycleLicenses?: Maybe<Array<Maybe<RecycleLicense>>>;
  /** Сток цеха */
  stock?: Maybe<Stock>;
  /** Список связок ползователь - цех */
  userToWorkshops?: Maybe<Array<Maybe<UserToWorkshop>>>;
  /** Ярд цеха */
  yard?: Maybe<Yard>;
};

/** Рабочее место */
export type Workspace = {
  __typename?: 'Workspace';
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Ссылка для перехода */
  url?: Maybe<Scalars['String']['output']>;
};

/** Ярд */
export type Yard = {
  __typename?: 'Yard';
  /** Адрес ярда */
  address?: Maybe<Scalars['String']['output']>;
  /** Контрагент */
  counterparty?: Maybe<Counterparty>;
  id: Scalars['ID']['output'];
  /** Признак что запущена инвентаризация */
  isActiveInventory: Scalars['Boolean']['output'];
  /** Признак что ярд участвует в расчете цен доставки с аукциона */
  isAucRoutePrice: Scalars['Boolean']['output'];
  /** Название ярда */
  name: Scalars['String']['output'];
  /** Сектора ярда */
  sectors?: Maybe<Array<Maybe<YardSector>>>;
  /** Список связок ползователь - ярд */
  userToYards?: Maybe<Array<Maybe<UserToYard>>>;
};

export type YardDashboard = {
  __typename?: 'YardDashboard';
  /** Общая стоимость авто */
  totalCost?: Maybe<Scalars['Float']['output']>;
  /** Количество авто */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Количество на ярдах */
  totalYard?: Maybe<Scalars['Int']['output']>;
  /** Список ярдов */
  yards?: Maybe<Array<Maybe<YardReport>>>;
};

/** Инвентаризация ярда */
export type YardInventory = {
  __typename?: 'YardInventory';
  /** Вывод даты разными способами */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Кто запустил */
  creator?: Maybe<User>;
  /** Вывод даты разными способами */
  finishedAt?: Maybe<Scalars['String']['output']>;
  /** Кто завершил */
  finisher?: Maybe<User>;
  id: Scalars['ID']['output'];
  /** Ярд */
  yard?: Maybe<Yard>;
};


/** Инвентаризация ярда */
export type YardInventoryCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Инвентаризация ярда */
export type YardInventoryFinishedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Объект инвентаризации ярда */
export type YardInventoryObject = {
  __typename?: 'YardInventoryObject';
  id: Scalars['ID']['output'];
  /** Изначально не было в списке */
  isNew: Scalars['Boolean']['output'];
  /** Вывод даты разными способами */
  markedAt?: Maybe<Scalars['String']['output']>;
  /** Водитель */
  user?: Maybe<User>;
  /** Машина */
  vehicle?: Maybe<Vehicle>;
};


/** Объект инвентаризации ярда */
export type YardInventoryObjectMarkedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  relative?: InputMaybe<Scalars['Boolean']['input']>;
};

export type YardReport = {
  __typename?: 'YardReport';
  /** Количество на ярде */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Машина */
  yard?: Maybe<Yard>;
};

/** Сектор ярда */
export type YardSector = {
  __typename?: 'YardSector';
  id: Scalars['ID']['output'];
  /** Название сектора */
  name: Scalars['String']['output'];
};

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshTokenMutation = { __typename?: 'Mutation', RefreshToken: { __typename?: 'RefreshToken', token?: string | null } };

export type SignInMutationVariables = Exact<{
  input: SignInInput;
}>;


export type SignInMutation = { __typename?: 'Mutation', SignIn: { __typename?: 'User', id: string, email?: string | null, name: string, token?: string | null, workspace?: { __typename?: 'Workspace', url?: string | null } | null, counterparty?: { __typename?: 'Counterparty', acceptedAucRulesAt?: string | null } | null } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, name: string, entityType: string, email?: string | null, token?: string | null, roles?: Array<{ __typename?: 'Workspace', name: string, id: string } | null> | null, currentLanguage?: { __typename?: 'Language', id: string, name: string, iso?: LanguageEnum | null } | null, counterparty?: { __typename?: 'Counterparty', id: string, acceptedAucRulesAt?: string | null, code: string, entityType: string, name: string, auctions?: Array<{ __typename?: 'Auction', id: string, nameEn: string, nameJp: string } | null> | null, bidType?: { __typename?: 'TypeOfBid', id: string } | null, freightPaymentType?: { __typename?: 'TypeOfFreight', id: string } | null, ports?: Array<{ __typename?: 'CounterpartyPort', id: string, port?: { __typename?: 'Port', id: string, name: string } | null } | null> | null } | null } | null };

export const RefreshTokenDocument = gql`
    mutation RefreshToken {
  RefreshToken(input: {refreshToken: "fake"}) {
    token
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RefreshTokenGQL extends Apollo.Mutation<RefreshTokenMutation, RefreshTokenMutationVariables> {
    override document = RefreshTokenDocument;
    override client = 'auth';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SignInDocument = gql`
    mutation SignIn($input: SignInInput!) {
  SignIn(input: $input) {
    id
    email
    name
    token
    workspace {
      url
    }
    counterparty {
      acceptedAucRulesAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SignInGQL extends Apollo.Mutation<SignInMutation, SignInMutationVariables> {
    override document = SignInDocument;
    override client = 'auth';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentUserDocument = gql`
    query currentUser {
  currentUser {
    id
    name
    entityType
    email
    token
    roles {
      name
      id
    }
    currentLanguage {
      id
      name
      iso
    }
    counterparty {
      id
      acceptedAucRulesAt
      code
      entityType
      name
      auctions {
        id
        nameEn
        nameJp
      }
      bidType {
        id
      }
      freightPaymentType {
        id
      }
      ports {
        id
        port {
          id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentUserGQL extends Apollo.Query<CurrentUserQuery, CurrentUserQueryVariables> {
    override document = CurrentUserDocument;
    override client = 'auth';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }